import * as tslib_1 from "tslib";
import { OnInit, OnDestroy, ElementRef } from '@angular/core';
import * as moment from 'moment';
import { SharedService } from 'src/app/shared/shared.service';
import { LoaderService } from 'src/app/loader.service';
import { ToasterService } from 'src/app/toaster.service';
import { Toaster, ToasterType } from 'src/app/shared/types/toaster.types';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/auth.service';
import { environment } from 'src/environments/environment';
import Utils from 'src/app/utils/utils';
import { SLAB_APPROVAL_PREVIEW_KEY_PREFIX, SlabApprovalRequestsService, } from '../slab-approval-requests/slab-approval-requests.service';
import { AlertDialogService } from '../shared/alert-dialog/alert-dialog.service';
import { AUTHZ_FEATURES } from '../constants/permissions';
import { permissionsForFeature } from '../auth.service';
import { AuthzAccessHintService } from '../shared/authz-access-hint/authz-access-hint.service';
var CreateSlabComponent = /** @class */ (function () {
    function CreateSlabComponent(sharedService, loader, toasterService, router, route, authService, slabApprovalRequestsService, alertDialogService, authzAccessHintService) {
        this.sharedService = sharedService;
        this.loader = loader;
        this.toasterService = toasterService;
        this.router = router;
        this.route = route;
        this.authService = authService;
        this.slabApprovalRequestsService = slabApprovalRequestsService;
        this.alertDialogService = alertDialogService;
        this.authzAccessHintService = authzAccessHintService;
        this.authzAccessHint = null;
        this.actionTitle = 'Add';
        this.isViewMode = false;
        this.isApprovalPreview = false;
        this.approvalRequestStatus = '';
        this.approvalRequestStatusDisplay = '';
        this.approvalRequestCreatedBy = '';
        this.approvalRequestApprovedBy = '';
        this.isApproved = false;
        this.canShowApprovalActions = false;
        this.canApprove = false;
        this.canReject = false;
        this.processingApprovalRequest = false;
        this.approvalActionMessage = '';
        this.currentUserEmail = '';
        this.hasApprovePermission = false;
        this.hasCreatePermission = false;
        this.isGeoSlabPage = false;
        this.loadingIndicator = false;
        this.showConfirmationModal = false;
        this.existingShiftSearch = '';
        this.existingServiceSearch = '';
        this.cities = [];
        this.services = [];
        this.allServices = [];
        this.shifts = [];
        this.serviceNames = {};
        this.serviceMap = {};
        this.earningModels = [];
        this.dashboardConfig = null;
        this.duplicateSlabConfigBlockHandled = false;
        this.mode = null;
        this.modes = [];
        this.selectedMode = null;
        this.selectedModeNames = [];
        this.oldApiShifts = [];
        this.newApiShifts = [];
        // Use configuration from server config
        this.isFetchingShiftsFromSlabEnabled = environment.isFetchingShiftsFromCaptainEarningsEnabled || false;
        this.categories = [];
        this.batchedFirstOrderCategories = ['order'];
        this.batchedNextOrderCategories = ['order'];
        this.daysList = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
        this.timeBasedSlabRuleTypes = ['percentage'];
        this.shiftSelection = 'existing';
        this.isFallbackSlab = false;
        /** True when default slab is on, city & mode are selected, and API returned no default shifts */
        this.defaultShiftsFetchedAndEmpty = false;
        this.category = null;
        this.selectedCities = null;
        this.selectedServiceNames = [];
        this.layers = [];
        this.selectedLayer = null;
        this.selectedGeoLayerType = 'hotspot';
        this.geoLayerTypes = [
            { id: 'hotspot', name: 'Hotspot' } //for now, only hotspot is supported
        ];
        this.geoFenceRadius = null;
        this.geoFenceAmount = null;
        this.layersLoading = false;
        this.layersError = false;
        this.existingGeoSlab = null;
        this.existingGeoSlabs = [];
        this.existingGeoSlabsLoading = false;
        this.existingGeoSlabLookupCount = 0;
        this.layersErrorMessage = 'Could not load layers. Please retry.';
        /**
         * From dashboard `minimumGuaranteeSlotCount`: maximum MG time slots allowed (≥1).
         * Users must keep at least one slot; they may use any count from 1 up to this maximum.
         */
        this.minimumGuaranteeSlotCount = 1;
        this.minimumGuaranteeBannerMessage = 'A slab with Minimum Guarantee already exists for this shift. You cannot modify these values. Please create a new shift to define different MG values.';
        this.isMinimumGuaranteeReadOnly = false;
        this.showMinimumGuaranteeBanner = false;
        /** While `/api/get/slabs` is in flight for the current MG (city/shift) context. */
        this.minimumGuaranteeSlabsLookupPending = false;
        /** Slabs API failed for the current context; use Retry to refetch. */
        this.minimumGuaranteeSlabsLookupError = false;
        this.minimumGuaranteeSlabsLookupErrorMessage = 'Could not load MG details from existing slabs. Please retry slab creation from the slab creation screen, or use Retry below.';
        this.microCorridors = [];
        this.selectedMicroCorridorIds = [];
        this.microCorridorsLoading = false;
        this.microCorridorsError = false;
        this.microCorridorsErrorCanRetry = true;
        this.defaultMicroCorridorsErrorMessage = 'Could not load MicroCorridors. Please retry.';
        this.microCorridorsEmptyErrorMessage = 'No MicroCorridors found. Please create a MicroCorridor for the above service.';
        this.microCorridorsErrorMessage = this.defaultMicroCorridorsErrorMessage;
        this.minimumGuaranteeShiftRequiresMicroCorridorId = false;
        this.flatCommissionDeductionsLoading = false;
        this.flatCommissionDeductionsError = false;
        this.flatCommissionTax = null;
        this.flatCommissionPlatformFee = null;
        this.flatCommissionDeductionDetails = [];
        this.flatCommissionDeductionsRequestId = 0;
        this.geoLayersRequestId = 0;
        this.existingGeoSlabLookupId = 0;
        this.fetchTaxesAndOrPlatformFeeErrorMessage = 'Could not load tax and platform fee details. Please retry.';
        this.flatCommissionInclusiveAmountNote = 'This commission amount is inclusive of rapido taxes (excluding captain taxes) and platform fees.';
        this.slabHasCommissionWithAdditionalDeductions = false;
        this.BatchedFirstOrderCategory = null;
        this.BatchedNextOrderCategory = null;
        this.isBatchedOrder = false;
        // First/Last mile
        this.thresholdDistanceFM = null;
        this.thresholdFareFM = null;
        this.maxCompensationFM = null;
        this.minCompensationFM = null;
        this.thresholdDistanceLM = null;
        this.thresholdFareLM = null;
        this.desiredCustomerPpkm = null;
        this.canSetDesiredCustomerPpkm = false;
        // Time-based slabs (distance category)
        this.timeBasedSlabs = [];
        this.params = {};
        this.startDateInput = null;
        this.finalSlabData = {};
        this.persistValues = {};
        this.minimumGuaranteeLookupCache = {};
        this.minimumGuaranteeLookupInFlight = {};
        this.minimumGuaranteeBannerDismissedByContext = {};
        this.currentMinimumGuaranteeContextKey = null;
        this.currentMicroCorridorContextKey = null;
        this.microCorridorLookupCache = {};
        this.microCorridorLookupInFlight = {};
        this.minimumGuaranteeLoaderVisible = false;
        this.minimumGuaranteeLoaderTaskId = 'create-slab-minimum-guarantee';
    }
    CreateSlabComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isGeoSlabPage = !!(this.route.snapshot.data && this.route.snapshot.data['geoSlab']);
        this.loadAccessHint();
        this.initDesiredCustomerPpkmPermission();
        this.initParams();
        var approvalRequestId = this.route.snapshot.paramMap.get('requestId');
        if (approvalRequestId) {
            this.isApprovalPreview = true;
            this.approvalRequestId = approvalRequestId;
            this.isViewMode = true;
            this.actionTitle = 'View';
            this.fetchCities().then(function () { return _this.loadApprovalPreviewFromConfigManager(approvalRequestId); });
            this.fetchDashboardConfig();
            return;
        }
        var slabId = this.route.snapshot.paramMap.get('id');
        var isDuplicate = this.route.snapshot.url.some(function (seg) { return seg.path === 'duplicate'; });
        if (slabId && isDuplicate) {
            this.isViewMode = false;
            this.actionTitle = 'Duplicate';
            this.fetchCities().then(function () { return _this.fetchSlabAndMap(slabId); });
            this.fetchDashboardConfig();
            return;
        }
        if (slabId) {
            this.isViewMode = true;
            this.actionTitle = 'View';
            this.fetchCities().then(function () { return _this.fetchSlabAndMap(slabId); });
            this.fetchDashboardConfig();
            return;
        }
        this.fetchCities().then(function () { return _this.applyLaunchQueryPrefill(); });
        this.fetchDashboardConfig();
    };
    CreateSlabComponent.prototype.loadAccessHint = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.authzAccessHintService.getAccessHintData('slab')];
                    case 1:
                        _a.authzAccessHint = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Prefill create form from CSCC city-launch query params:
     * CSCC sends city/service ids; display names are resolved locally.
     */
    CreateSlabComponent.prototype.applyLaunchQueryPrefill = function () {
        var _this = this;
        var q = this.route.snapshot.queryParams || {};
        var cityId = (q['city'] || '').trim();
        var modeId = (q['mode'] || '').trim();
        var serviceTypes = String(q['serviceTypes'] || '')
            .split(',')
            .map(function (s) { return s.trim(); })
            .filter(Boolean);
        if (!cityId) {
            return;
        }
        var city = this.cities.find(function (c) { return String(c._id) === String(cityId); });
        if (!city) {
            return;
        }
        this.selectedCities = city.displayName;
        this.clearFlatCommissionDeductions();
        this.defaultShiftsFetchedAndEmpty = false;
        this.shifts = [];
        this.params.shift = [];
        this.oldApiShifts = [];
        this.newApiShifts = [];
        this.selectedMode = null;
        this.selectedModeNames = [];
        this.modes = [];
        this.services = [];
        this.allServices = [];
        this.params.serviceTypes = [];
        if (!this.isFetchingShiftsFromSlabEnabled) {
            this.fetchNewShifts(city.displayName);
        }
        this.getCityServices(city.displayName, function () {
            _this.sharedService.fetchModes(city._id).toPromise()
                .then(function (res) {
                _this.modes = (res && res.data && res.data.modes) || [];
                if (!modeId) {
                    _this.showError('Mode is required in launch URL.');
                    return;
                }
                var matchedMode = _this.modes.find(function (m) { return String(m.id) === String(modeId); });
                if (!matchedMode) {
                    _this.showError('Invalid mode in launch URL for the selected city.');
                    return;
                }
                _this.selectedMode = String(matchedMode.id);
                _this.filterServicesByMode();
                if (!serviceTypes.length) {
                    _this.showError('serviceTypes is required in launch URL.');
                    return;
                }
                var unknownServiceTypes = serviceTypes.filter(function (id) {
                    return !_this.allServices.some(function (s) { return String(s._id) === String(id); });
                });
                if (unknownServiceTypes.length) {
                    _this.showError('Invalid serviceTypes in launch URL for the selected city.');
                    return;
                }
                var mismatchedModeServiceTypes = serviceTypes.filter(function (id) {
                    var entry = _this.serviceMap[id];
                    var serviceModeId = entry && entry.mode;
                    return !serviceModeId || String(serviceModeId) !== String(_this.selectedMode);
                });
                if (mismatchedModeServiceTypes.length) {
                    _this.showError('serviceTypes do not match the mode in launch URL.');
                    return;
                }
                _this.params.serviceTypes = serviceTypes.slice();
                _this.selectedServiceNames = serviceTypes.map(function (id) { return _this.serviceNames[id] || id; });
                _this.servicesChanged();
                _this.loadShiftsListForCurrentCityAndMode();
                _this.evaluateMinimumGuaranteeState(true);
                _this.evaluateFlatCommissionDeductionsState();
            })
                .catch(function (err) { return console.error('Launch query mode prefill failed', err); });
        });
    };
    CreateSlabComponent.prototype.ngOnDestroy = function () {
        if (this.minimumGuaranteeLoaderVisible) {
            this.minimumGuaranteeLoaderVisible = false;
            this.loader.closeLoading(this.minimumGuaranteeLoaderTaskId);
        }
    };
    CreateSlabComponent.prototype.syncMinimumGuaranteeLoadingOverlay = function () {
        var shouldShow = this.minimumGuaranteeSlabsLookupPending || this.microCorridorsLoading;
        if (shouldShow === this.minimumGuaranteeLoaderVisible) {
            return;
        }
        this.minimumGuaranteeLoaderVisible = shouldShow;
        if (shouldShow) {
            this.loader.openLoading(this.minimumGuaranteeLoaderTaskId);
            return;
        }
        this.loader.closeLoading(this.minimumGuaranteeLoaderTaskId);
    };
    CreateSlabComponent.prototype.initParams = function () {
        this.params = {
            excludeIncentiveTypes: [],
            peakSlab: { timeData: [{}], slabData: { slabs: [{}] } },
            peakSlabBatchedFirstOrder: { timeData: [{}], slabData: { slabs: [{}] } },
            peakSlabBatchedNextOrder: { timeData: [{}], slabData: { slabs: [{}] } },
            nonPeakSlab: { timeData: [{}], slabData: { slabs: [{}] } },
            nonPeakSlabBatchedFirstOrder: { timeData: [{}], slabData: { slabs: [{}] } },
            nonPeakSlabBatchedNextOrder: { timeData: [{}], slabData: { slabs: [{}] } },
            flexibleSlab: { timeData: [{}], slabData: { slabs: [{}] } },
            flexibleSlabBatchedFirstOrder: { timeData: [{}], slabData: { slabs: [{}] } },
            flexibleSlabBatchedNextOrder: { timeData: [{}], slabData: { slabs: [{}] } },
            nightSlab: { timeData: [{}], slabData: { slabs: [{}] } },
            nightSlabBatchedFirstOrder: { timeData: [{}], slabData: { slabs: [{}] } },
            nightSlabBatchedNextOrder: { timeData: [{}], slabData: { slabs: [{}] } },
            calculationType: 'daily',
            isSalaried: false,
            isFallbackSlab: false,
            payrollVersion: 2.0,
            poolSize: null,
            poolMultipliers: {},
        };
    };
    CreateSlabComponent.prototype.fetchCities = function () {
        var _this = this;
        this.loader.openLoading();
        return this.sharedService.fetchCities().toPromise()
            .then(function (res) {
            _this.cities = (res.data.cities || [])
                .filter(function (c) { return c.active; })
                .map(function (c) { return ({
                _id: c._id,
                displayName: c.displayName,
                shortName: c.shortName
            }); });
        })
            .catch(function () { return _this.showError('Error fetching cities'); })
            .finally(function () { return _this.loader.closeLoading(); });
    };
    CreateSlabComponent.prototype.loadApprovalPreviewFromConfigManager = function (requestId) {
        var _this = this;
        this.loader.openLoading();
        this.slabApprovalRequestsService.fetchApprovalRequestById(requestId)
            .subscribe(function (row) {
            if (!row || row.newValue == null) {
                _this.loader.closeLoading();
                _this.showError('Approval request not found');
                return;
            }
            _this.applyApprovalRequestRow(requestId, row);
        }, function () {
            var previewData = _this.readApprovalPreview(requestId);
            if (!previewData) {
                _this.loader.closeLoading();
                _this.showError('Approval preview data not found for request');
                return;
            }
            var context = _this.approvalPreviewContext || { requestId: requestId, newValue: previewData };
            _this.applyApprovalRequestRow(requestId, tslib_1.__assign({}, context, { newValue: previewData }));
        });
    };
    CreateSlabComponent.prototype.applyApprovalRequestRow = function (requestId, row) {
        var requestStatus = row ? String(row.requestStatus || row.status || '').trim() : '';
        this.approvalPreviewContext = {
            requestId: requestId,
            requestStatus: requestStatus,
            operation: row.operation,
            createdBy: row.createdBy,
            resourceId: row.resourceId,
            resource: row.resource,
            key: row.key,
            version: row.version,
            newValue: row.newValue,
            oldValue: row.oldValue || null,
        };
        this.approvalRequestStatus = requestStatus;
        var normalized = requestStatus.trim().toLowerCase();
        this.approvalRequestStatusDisplay = requestStatus
            ? normalized.charAt(0).toUpperCase() + normalized.slice(1)
            : 'Unknown';
        this.approvalRequestCreatedBy = row.createdBy || '';
        this.isApproved = normalized === 'approved';
        this.approvalRequestApprovedBy = this.isApproved ? (row.statusChangedBy || '') : '';
        this.initApprovalPermissions();
        this.mapApiSlabToForm(row.newValue);
        this.loader.closeLoading();
    };
    CreateSlabComponent.prototype.readApprovalPreview = function (requestId) {
        var raw = sessionStorage.getItem("" + SLAB_APPROVAL_PREVIEW_KEY_PREFIX + requestId);
        if (!raw) {
            return null;
        }
        try {
            var parsed = JSON.parse(raw);
            if (parsed && parsed.newValue != null) {
                this.approvalPreviewContext = parsed;
                this.updateApprovalActionVisibility();
                return parsed.newValue;
            }
            this.approvalPreviewContext = { requestId: requestId, newValue: parsed };
            this.updateApprovalActionVisibility();
            return parsed;
        }
        catch (error) {
            return null;
        }
    };
    CreateSlabComponent.prototype.initDesiredCustomerPpkmPermission = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, this.authService.isAuthorizedFor('slab_desired_customer_ppkm')];
                    case 1:
                        _a.canSetDesiredCustomerPpkm = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        this.canSetDesiredCustomerPpkm = false;
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CreateSlabComponent.prototype.initApprovalPermissions = function () {
        var _this = this;
        this.authService.getUserDetails().subscribe(function (user) {
            var slabPermissions = permissionsForFeature(AUTHZ_FEATURES.SLAB, _this.authService.getAuthzPanels());
            _this.hasApprovePermission = _this.authService.isAuthorizedFor(slabPermissions.approve, AUTHZ_FEATURES.SLAB);
            _this.hasCreatePermission = _this.authService.isAuthorizedFor(slabPermissions.create, AUTHZ_FEATURES.SLAB);
            _this.currentUserEmail = (user && user.email) || '';
            _this.updateApprovalActionVisibility();
        });
    };
    CreateSlabComponent.prototype.updateApprovalActionVisibility = function () {
        var status = (this.approvalRequestStatus || '').toLowerCase();
        var isPending = !status || status === 'pending';
        var isSelfCreated = this.isSamePersonAsRequestCreator();
        // Approve: requires approve_slab permission AND not self-created
        this.canApprove = this.hasApprovePermission && !isSelfCreated && isPending;
        // Reject: requires approve_slab OR (self-created AND create_slab)
        this.canReject = isPending && (this.hasApprovePermission || (isSelfCreated && this.hasCreatePermission));
        // Show actions section if either action is available
        this.canShowApprovalActions = this.canApprove || this.canReject;
        // Set message when buttons are hidden
        this.approvalActionMessage = '';
        if (!this.canShowApprovalActions && status) {
            if (!this.hasApprovePermission && !(isSelfCreated && this.hasCreatePermission)) {
                this.approvalActionMessage = "You don't have permission to approve or reject slab requests";
            }
            else if (!isPending) {
                this.approvalActionMessage = "Approve and Reject are only available while the request is pending";
            }
        }
    };
    CreateSlabComponent.prototype.isSamePersonAsRequestCreator = function () {
        var creator = this.approvalPreviewContext && this.approvalPreviewContext.createdBy;
        if (!creator || !this.currentUserEmail) {
            return false;
        }
        return (creator || '').trim().toLowerCase() === (this.currentUserEmail || '').trim().toLowerCase();
    };
    CreateSlabComponent.prototype.approveSlabRequest = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isSamePersonAsRequestCreator()) {
                            this.alertDialogService.open({
                                title: 'Cannot approve',
                                message: 'This request cannot be approved by the same person who submitted it. Please ask another approver to review this request.',
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.submitApprovalRequest('approve')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateSlabComponent.prototype.rejectSlabRequest = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.submitApprovalRequest('reject')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateSlabComponent.prototype.submitApprovalRequest = function (action) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resource, body, request$, error_2, message;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.approvalRequestId || this.processingApprovalRequest) {
                            return [2 /*return*/];
                        }
                        this.processingApprovalRequest = true;
                        this.loader.openLoading();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        if (!this.approvalPreviewContext) {
                            throw { error: { message: 'Approval request data is missing. Re-open the request from the list.' } };
                        }
                        resource = this.approvalPreviewContext.resource || 'slabs';
                        body = { resource: resource, comment: action === 'approve' ? 'Approved' : 'Rejected' };
                        request$ = action === 'approve'
                            ? this.slabApprovalRequestsService.approveRequest(this.approvalRequestId, body)
                            : this.slabApprovalRequestsService.rejectRequest(this.approvalRequestId, body);
                        return [4 /*yield*/, request$.toPromise()];
                    case 2:
                        _a.sent();
                        this.alertDialogService.open({
                            title: 'Success',
                            message: action === 'approve'
                                ? 'Slab approval request was approved successfully.'
                                : 'Slab approval request was rejected successfully.',
                        });
                        this.canShowApprovalActions = false;
                        this.approvalRequestStatus = action === 'approve' ? 'approved' : 'rejected';
                        this.approvalRequestStatusDisplay = action === 'approve' ? 'Approved' : 'Rejected';
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        message = (error_2 && error_2.error && error_2.error.message)
                            || (error_2 && error_2.error && error_2.error.data && error_2.error.data.error)
                            || (action === 'approve'
                                ? 'Failed to approve slab request.'
                                : 'Failed to reject slab request.');
                        this.alertDialogService.open({
                            title: 'Failed',
                            message: message,
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        this.processingApprovalRequest = false;
                        this.loader.closeLoading();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CreateSlabComponent.prototype.goBackFromSlabView = function () {
        if (this.isApprovalPreview) {
            this.router.navigate(['/slab-approval-requests']);
            return;
        }
        this.router.navigate(['/slabs']);
    };
    CreateSlabComponent.prototype.fetchSlabAndMap = function (slabId) {
        var _this = this;
        this.loader.openLoading();
        this.sharedService.getSlab(slabId).toPromise()
            .then(function (res) {
            var slab = res && res.data != null ? res.data : res;
            if (!slab) {
                _this.showError('Slab not found');
                return;
            }
            _this.mapApiSlabToForm(slab);
        })
            .catch(function (err) {
            var msg = (err && err.error && err.error.message) || (err && err.message) || 'Error loading slab';
            _this.showError(msg);
        })
            .finally(function () { return _this.loader.closeLoading(); });
    };
    CreateSlabComponent.prototype.getViewModeServiceDisplayText = function () {
        var _this = this;
        if (this.selectedServiceNames && this.selectedServiceNames.length > 0) {
            return this.selectedServiceNames.join(', ');
        }
        var ids = (this.params && this.params.serviceTypes) || [];
        return ids.map(function (id) { return _this.serviceNames[id] || id; }).join(', ');
    };
    /**
     * Maps GET slab API response into component form model (params and related state).
     * Extend when API response shape is known.
     */
    CreateSlabComponent.prototype.mapApiSlabToForm = function (slab) {
        var _this = this;
        if (slab && slab.slab && typeof slab.slab === 'object') {
            slab = slab.slab;
        }
        var categoryKeys = ['category', 'type', 'categoryType', 'slabCategory', 'slab_category'];
        var rawCategory = null;
        for (var _i = 0, categoryKeys_1 = categoryKeys; _i < categoryKeys_1.length; _i++) {
            var key = categoryKeys_1[_i];
            var val = key.indexOf('_') !== -1 ? slab[key] : slab[key];
            if (val != null && val !== '') {
                rawCategory = val;
                break;
            }
        }
        if (rawCategory == null && slab.data && typeof slab.data === 'object') {
            for (var _a = 0, categoryKeys_2 = categoryKeys; _a < categoryKeys_2.length; _a++) {
                var key = categoryKeys_2[_a];
                var val = slab.data[key];
                if (val != null && val !== '') {
                    rawCategory = val;
                    break;
                }
            }
        }
        if (rawCategory == null && slab && typeof slab === 'object') {
            rawCategory = slab.peakSlab.slabData.category;
        }
        if (rawCategory != null) {
            var normalized = typeof rawCategory === 'string' ? rawCategory.trim().toLowerCase() : String(rawCategory).toLowerCase();
            this.category = this.categories.indexOf(normalized) !== -1 ? normalized : rawCategory;
        }
        var modeId = slab.modeInfo && slab.modeInfo._id;
        var cityDisplayName = Array.isArray(slab.cities) && slab.cities.length > 0
            ? (typeof slab.cities[0] === 'string' ? slab.cities[0] : (slab.cities[0].displayName || slab.cities[0].name))
            : (slab.cities && typeof slab.cities === 'string' ? slab.cities : null);
        // Extract serviceIds from slab
        var serviceTypesFromSlab = slab.serviceTypes && Array.isArray(slab.serviceTypes) ? slab.serviceTypes : [];
        if (cityDisplayName) {
            this.selectedCities = cityDisplayName;
            var cityObj = this.cities.find(function (c) { return c.displayName === cityDisplayName; });
            if (cityObj) {
                // In view mode or duplicate mode, fetch modes using serviceIds
                if ((this.isViewMode || this.actionTitle === 'Duplicate') && serviceTypesFromSlab.length > 0) {
                    var serviceNamesFromSlab = slab.serviceNames && Array.isArray(slab.serviceNames) ? slab.serviceNames : null;
                    this.fetchModesByServiceDetailIdsAndValidate(serviceTypesFromSlab, modeId, cityDisplayName, serviceTypesFromSlab, serviceNamesFromSlab);
                }
                else {
                    var presetModeId = modeId ? String(modeId) : null;
                    this.fetchModesForCity(cityObj._id, presetModeId);
                    var serviceNamesFromSlab_1 = slab.serviceNames && Array.isArray(slab.serviceNames) ? slab.serviceNames : null;
                    this.getCityServices(cityDisplayName, function () {
                        _this.params.serviceTypes = serviceTypesFromSlab;
                        _this.selectedServiceNames = serviceNamesFromSlab_1 != null && serviceNamesFromSlab_1.length > 0
                            ? serviceNamesFromSlab_1
                            : (_this.params.serviceTypes || []).map(function (id) { return _this.serviceNames[id] || id; });
                        _this.servicesChanged();
                    });
                }
            }
        }
        if (modeId && !this.isViewMode) {
            this.selectedMode = String(modeId);
        }
        if (slab.serviceTypes && Array.isArray(slab.serviceTypes)) {
            this.params.serviceTypes = slab.serviceTypes;
        }
        else if (slab.serviceNames && Array.isArray(slab.serviceNames)) {
            this.params.serviceTypes = slab.serviceTypes || [];
        }
        if (slab.shift != null) {
            this.params.shift = Array.isArray(slab.shift) ? slab.shift.slice() : [slab.shift];
            this.shifts = Array.isArray(slab.shift) ? slab.shift.slice() : [slab.shift];
        }
        if (slab.startDate != null) {
            this.params.startDate = typeof slab.startDate === 'string' ? slab.startDate.split('T')[0] : slab.startDate;
        }
        if (slab.endDate != null) {
            this.params.endDate = typeof slab.endDate === 'string' ? slab.endDate.split('T')[0] : slab.endDate;
        }
        if (slab.days != null) {
            this.params.days = Array.isArray(slab.days) ? slab.days.slice() : slab.days;
        }
        if (slab.slabMessage != null || slab.slab_message != null) {
            this.params.slabMessage = slab.slabMessage != null ? slab.slabMessage : slab.slab_message;
        }
        if (slab.batchedOrder != null) {
            this.isBatchedOrder = !!slab.batchedOrder;
        }
        if (slab.isFallbackSlab != null) {
            this.isFallbackSlab = !!slab.isFallbackSlab;
            this.params.isFallbackSlab = !!slab.isFallbackSlab;
        }
        // Pool config comes from captain-earnings as poolDetails { size, compensationMultipliers };
        // flatten it into the form fields
        var poolDetails = slab.poolDetails;
        if (poolDetails != null) {
            this.params.poolSize = poolDetails.size;
            this.params.poolMultipliers = Utils.normalizePoolMultipliers(poolDetails.compensationMultipliers);
        }
        this.BatchedFirstOrderCategory = slab.BatchedFirstOrderCategory != null ? slab.BatchedFirstOrderCategory : (slab.batchedFirstOrderCategory != null ? slab.batchedFirstOrderCategory : null);
        this.BatchedNextOrderCategory = slab.BatchedNextOrderCategory != null ? slab.BatchedNextOrderCategory : (slab.batchedNextOrderCategory != null ? slab.batchedNextOrderCategory : null);
        var thresholdDistanceFM = slab.thresholdDistanceFM != null ? slab.thresholdDistanceFM : slab.threshold_distance_fm;
        var thresholdFareFM = slab.thresholdFareFM != null ? slab.thresholdFareFM : slab.threshold_fare_fm;
        this.thresholdDistanceFM = thresholdDistanceFM != null ? thresholdDistanceFM : null;
        this.thresholdFareFM = thresholdFareFM != null ? thresholdFareFM : null;
        this.maxCompensationFM = slab.maxCompensationFM != null ? slab.maxCompensationFM : null;
        this.minCompensationFM = slab.minCompensationFM != null ? slab.minCompensationFM : null;
        this.thresholdDistanceLM = slab.thresholdDistanceLM != null ? slab.thresholdDistanceLM : null;
        this.thresholdFareLM = slab.thresholdFareLM != null ? slab.thresholdFareLM : null;
        this.desiredCustomerPpkm = slab.desiredCustomerPpkm != null ? slab.desiredCustomerPpkm : null;
        if ((this.isViewMode || this.actionTitle === 'Duplicate') && modeId) {
            this.mode = String(modeId);
            if (this.isViewMode && !this.selectedMode) {
                this.selectedMode = String(modeId);
            }
            if (this.isViewMode && slab.modeInfo && slab.modeInfo.name) {
                this.selectedModeNames = [slab.modeInfo.name];
            }
        }
        var slabKeys = [
            'excludeIncentiveTypes', 'calculationType', 'isSalaried', 'payrollVersion',
            'commissionType', 'commissionAmount', 'commissionOnBonus',
            'commissionTypeBatchedFirstOrder', 'commissionAmountBatchedFirstOrder', 'commissionOnBonusBatchedFirstOrder',
            'commissionTypeBatchedNextOrder', 'commissionAmountBatchedNextOrder', 'commissionOnBonusBatchedNextOrder',
            'peakSlab', 'nonPeakSlab', 'flexibleSlab', 'nightSlab',
            'peakSlabBatchedFirstOrder', 'nonPeakSlabBatchedFirstOrder', 'flexibleSlabBatchedFirstOrder', 'nightSlabBatchedFirstOrder',
            'peakSlabBatchedNextOrder', 'nonPeakSlabBatchedNextOrder', 'flexibleSlabBatchedNextOrder', 'nightSlabBatchedNextOrder',
            'earningModel', 'minimumPayout', 'timeBasedSlabs', 'batchDetails', 'slabMessage',
            'isSurgeIncluded', 'isSurgeIncludedBatchedFirstOrder', 'isSurgeIncludedBatchedNextOrder',
            'minimumGuaranteeDetails'
        ];
        slabKeys.forEach(function (k) {
            if (slab[k] !== undefined && slab[k] !== null) {
                if (typeof slab[k] === 'object' && !Array.isArray(slab[k]) && _this.params[k] && typeof _this.params[k] === 'object') {
                    _this.params[k] = JSON.parse(JSON.stringify(slab[k]));
                }
                else {
                    _this.params[k] = slab[k];
                }
            }
        });
        var inclusiveCommission = slab.commissionWithAdditionalDeductions;
        this.slabHasCommissionWithAdditionalDeductions =
            inclusiveCommission != null && inclusiveCommission !== '';
        if (this.slabHasCommissionWithAdditionalDeductions) {
            this.params.commissionAmount = inclusiveCommission;
        }
        this.selectedServiceNames = (this.params.serviceTypes || []).map(function (id) { return _this.serviceNames[id] || id; });
        if (slab.serviceNames && Array.isArray(slab.serviceNames)) {
            this.selectedServiceNames = slab.serviceNames;
        }
        if (!this.category && this.params.earningModel) {
            var em = String(this.params.earningModel).trim().toLowerCase();
            if (this.categories.indexOf(em) !== -1) {
                this.category = em;
            }
        }
        if (this.params.timeBasedSlabs && Array.isArray(this.params.timeBasedSlabs) && this.params.timeBasedSlabs.length > 0) {
            this.timeBasedSlabs = this.params.timeBasedSlabs.map(function (tb) { return ({
                startTime: tb.startTime,
                endTime: tb.endTime,
                rules: Array.isArray(tb.rules) && tb.rules.length > 0
                    ? tb.rules.map(function (r) { return ({ type: r.type || 'percentage', value: r.value }); })
                    : [{ type: 'percentage', value: null }]
            }); });
        }
        this.setEarningModels();
        this.evaluateFlatCommissionDeductionsState();
        this.blockDuplicateFlowIfSlabCategoryNotInConfig();
    };
    CreateSlabComponent.prototype.blockDuplicateFlowIfSlabCategoryNotInConfig = function () {
        if (this.actionTitle !== 'Duplicate' || this.duplicateSlabConfigBlockHandled || !this.category || !this.dashboardConfig) {
            return;
        }
        var modeId = this.mode || this.selectedMode;
        if (!modeId) {
            return;
        }
        if (this.sharedService.isSlabCategoryConfiguredForMode(this.dashboardConfig, modeId, this.category)) {
            return;
        }
        this.duplicateSlabConfigBlockHandled = true;
        var categoryTitle = String(this.category);
        this.showError("Duplicating \"" + categoryTitle + "\" category slab is not allowed.");
        this.router.navigate(['/slabs']);
    };
    CreateSlabComponent.prototype.fetchNewShifts = function (cityDisplayName) {
        var _this = this;
        if (!cityDisplayName) {
            return;
        }
        this.sharedService.fetchShifts(cityDisplayName).toPromise()
            .then(function (res) {
            var data = Array.isArray(res) ? res : (res && res.data ? res.data : []);
            // Store raw data without "All" - we'll add it during merge
            _this.oldApiShifts = data;
            _this.mergeAndSetShifts();
        })
            .catch(function (err) { return console.error('Fetch old shifts error', err); });
    };
    CreateSlabComponent.prototype.fetchModesForCity = function (cityId, presetModeId) {
        var _this = this;
        if (!cityId) {
            return;
        }
        this.sharedService.fetchModes(cityId).toPromise()
            .then(function (res) {
            _this.modes = (res && res.data && res.data.modes) || [];
            _this.selectedModeNames = [];
            if (presetModeId) {
                _this.selectedMode = presetModeId;
                _this.filterServicesByMode();
            }
            if (_this.actionTitle === 'Duplicate' && _this.selectedCities && _this.selectedMode) {
                _this.loadShiftsListForCurrentCityAndMode();
            }
        })
            .catch(function (err) { return console.error('Fetch modes error', err); });
    };
    CreateSlabComponent.prototype.fetchModesByServiceDetailIdsAndValidate = function (serviceDetailIds, slabModeId, cityDisplayName, serviceTypesFromSlab, serviceNamesFromSlab) {
        var _this = this;
        if (!serviceDetailIds || serviceDetailIds.length === 0)
            return;
        this.sharedService.fetchModesByServiceDetailIds(serviceDetailIds).toPromise()
            .then(function (res) {
            var modes = (res && res.data && res.data.modes) || [];
            _this.modes = modes;
            var uniqueModeIds = Array.from(new Set(modes.map(function (m) { return m.id; }).filter(Boolean)));
            _this.selectedModeNames = Array.from(new Set(modes.map(function (m) { return m.name; }).filter(Boolean)));
            var slabMode = slabModeId ? String(slabModeId) : uniqueModeIds.length === 1 ? String(uniqueModeIds[0]) : null;
            var isSingleMode = uniqueModeIds.length === 1;
            var modeMatches = isSingleMode && slabMode === uniqueModeIds[0];
            _this.selectedMode = isSingleMode ? String(uniqueModeIds[0]) : null;
            _this.getCityServices(cityDisplayName, function () {
                _this.filterServicesByMode();
                var isViewOrDuplicate = _this.actionTitle === 'Duplicate' || _this.isViewMode;
                if (isViewOrDuplicate) {
                    var validServiceIds = serviceDetailIds.filter(function (id) {
                        return _this.allServices.some(function (s) { return String(s._id) === String(id); });
                    });
                    _this.params.serviceTypes = validServiceIds;
                    _this.selectedServiceNames = serviceNamesFromSlab && serviceNamesFromSlab.length > 0
                        ? serviceNamesFromSlab
                        : validServiceIds.map(function (id) { return _this.serviceNames[id] || id; });
                    _this.servicesChanged();
                    if (_this.actionTitle === 'Duplicate') {
                        _this.loadShiftsListForCurrentCityAndMode();
                    }
                    if (_this.isViewMode && !modeMatches) {
                        console.warn('Mode mismatch (view mode):', slabMode, uniqueModeIds);
                    }
                }
                else {
                    console.warn('Mode mismatch:', slabMode, uniqueModeIds);
                    _this.params.serviceTypes = [];
                    _this.selectedServiceNames = [];
                }
            });
        })
            .catch(function (err) {
            console.error('Fetch modes error:', err);
            var city = _this.cities.find(function (c) { return c.displayName === cityDisplayName; });
            if (city)
                _this.fetchModesForCity(city._id);
        });
    };
    CreateSlabComponent.prototype.loadShiftsListForCurrentCityAndMode = function () {
        var _this = this;
        if (!this.selectedCities || !this.selectedMode) {
            return;
        }
        var cityObj = this.cities.find(function (c) { return c.displayName === _this.selectedCities; });
        if (!cityObj) {
            return;
        }
        if (!this.isFetchingShiftsFromSlabEnabled) {
            this.fetchNewShifts(this.selectedCities);
        }
        this.fetchCaptainShifts(cityObj._id, this.selectedMode, this.params.isFallbackSlab);
    };
    CreateSlabComponent.prototype.fetchCaptainShifts = function (cityId, modeId, isDefault) {
        var _this = this;
        if (!cityId || !modeId) {
            return;
        }
        this.defaultShiftsFetchedAndEmpty = false;
        this.sharedService.fetchCaptainEarningsShifts(cityId, modeId, isDefault).toPromise()
            .then(function (res) {
            var arr = [];
            if (res && res.data && res.data.shifts && Array.isArray(res.data.shifts)) {
                arr = res.data.shifts;
            }
            else if (res && res.data && Array.isArray(res.data)) {
                arr = res.data;
            }
            else if (Array.isArray(res)) {
                arr = res;
            }
            _this.newApiShifts = arr
                .map(function (s) { return (typeof s === 'object' && s !== null) ? (s.name || '') : String(s); })
                .filter(function (name) { return name.trim() !== ''; });
            _this.mergeAndSetShifts();
            _this.defaultShiftsFetchedAndEmpty = !!(isDefault && _this.shifts.length === 0);
            _this.applyFallbackSingleShiftSelection();
        })
            .catch(function (err) { return console.error('Fetch captain shifts error', err); });
    };
    CreateSlabComponent.prototype.applyFallbackSingleShiftSelection = function () {
        if (!this.isFallbackSlab || this.isViewMode) {
            return;
        }
        if (this.shiftSelection !== 'existing') {
            return;
        }
        if (this.defaultShiftsFetchedAndEmpty) {
            return;
        }
        if (this.shifts.length !== 1) {
            return;
        }
        this.params.shift = [this.shifts[0]];
    };
    CreateSlabComponent.prototype.isFallbackShiftsReadonlyBox = function () {
        if (!this.isFallbackSlab || this.shiftSelection !== 'existing') {
            return false;
        }
        if (this.defaultShiftsFetchedAndEmpty) {
            return false;
        }
        if (this.shifts.length === 1) {
            return true;
        }
        return this.isViewMode && Array.isArray(this.params.shift) && this.params.shift.length === 1;
    };
    CreateSlabComponent.prototype.getFallbackShiftDisplayName = function () {
        if (this.shifts.length === 1) {
            return this.shifts[0];
        }
        if (this.params.shift && this.params.shift.length > 0) {
            return this.params.shift[0];
        }
        return '';
    };
    CreateSlabComponent.prototype.mergeAndSetShifts = function () {
        if (this.isFetchingShiftsFromSlabEnabled) {
            // Toggle ON: new API only
            var unique = this.newApiShifts.filter(function (v, i, a) { return a.indexOf(v) === i; });
            this.shifts = unique;
        }
        else {
            var seen_1 = {};
            var merged_1 = [];
            this.oldApiShifts.forEach(function (s) {
                if (s && !seen_1[s]) {
                    seen_1[s] = true;
                    merged_1.push(s);
                }
            });
            this.newApiShifts.forEach(function (s) {
                if (s && !seen_1[s]) {
                    seen_1[s] = true;
                    merged_1.push(s);
                }
            });
            this.shifts = merged_1;
        }
    };
    CreateSlabComponent.prototype.onModeChange = function () {
        var _this = this;
        this.defaultShiftsFetchedAndEmpty = false;
        this.newApiShifts = [];
        this.mergeAndSetShifts();
        this.filterServicesByMode();
        this.params.shift = [];
        if (this.params.serviceTypes && this.params.serviceTypes.length > 0) {
            var validServices = this.services.filter(function (s) {
                return _this.params.serviceTypes.includes(s._id);
            });
            if (validServices.length === 0) {
                this.params.serviceTypes = [];
                this.servicesChanged();
            }
        }
        if (!this.selectedMode || !this.selectedCities) {
            return;
        }
        var cityObj = this.cities.find(function (c) { return c.displayName === _this.selectedCities; });
        if (!this.isGeoSlabPage && cityObj) {
            this.fetchCaptainShifts(cityObj._id, this.selectedMode, this.params.isFallbackSlab);
        }
        this.evaluateMinimumGuaranteeState(true);
        if (this.isGeoSlabPage) {
            this.selectedLayer = null;
            this.layers = [];
            this.refreshGeoSlabLayers();
            this.lookupExistingGeoSlab();
        }
    };
    CreateSlabComponent.prototype.onDefaultSlabToggle = function () {
        var _this = this;
        this.params.isFallbackSlab = !!this.isFallbackSlab;
        this.defaultShiftsFetchedAndEmpty = false;
        this.filterServicesByMode();
        if (!this.selectedMode || !this.selectedCities) {
            return;
        }
        var cityObj = this.cities.find(function (c) { return c.displayName === _this.selectedCities; });
        if (cityObj) {
            this.params.shift = [];
            this.shifts = [];
            this.newApiShifts = [];
            this.mergeAndSetShifts();
            this.fetchCaptainShifts(cityObj._id, this.selectedMode, this.params.isFallbackSlab);
        }
        this.evaluateMinimumGuaranteeState(true);
    };
    CreateSlabComponent.prototype.openStartDatePicker = function () {
        var ref = this.startDateInput;
        var el = ref ? ref.nativeElement : null;
        if (!el)
            return;
        var input = el;
        if (typeof input.showPicker === 'function') {
            input.showPicker();
        }
        else {
            el.focus();
            el.click();
        }
    };
    CreateSlabComponent.prototype.getCityServices = function (cityDisplayName, onLoaded) {
        var _this = this;
        this.services = [];
        this.allServices = [];
        // Don't clear serviceTypes in view/duplicate — they will be set in the callback
        if (!this.isViewMode && this.actionTitle !== 'Duplicate') {
            this.params.serviceTypes = [];
        }
        if (!cityDisplayName) {
            return;
        }
        var cityObj = this.cities.find(function (c) { return c.displayName === cityDisplayName; });
        if (!cityObj) {
            return;
        }
        var cityId = cityObj._id;
        this.sharedService.cityService(cityId).toPromise()
            .then(function (res) {
            _this.allServices = Array.isArray(res) ? res : (res && res.data ? res.data : []);
            _this.serviceNames = {};
            _this.serviceMap = {};
            _this.allServices.forEach(function (s) {
                _this.serviceNames[s._id] = s.service && s.service.name;
                var modeId = (s.modeInfo && (s.modeInfo._id || s.modeInfo.name)) || s.mode || null;
                _this.serviceMap[s._id] = {
                    mode: modeId,
                    modeInfo: s.modeInfo,
                    orderType: s.orderType,
                    geoServiceGroupId: s.service && s.service.geoServiceGroupId
                };
            });
            _this.filterServicesByMode();
            _this.servicesChanged();
            if (onLoaded) {
                onLoaded();
            }
        })
            .catch(function (err) {
            console.error(err);
            _this.showError('Error fetching services');
        });
    };
    CreateSlabComponent.prototype.filterServicesByMode = function () {
        var _this = this;
        var filteredServices;
        if (!this.selectedMode) {
            filteredServices = this.allServices.slice();
        }
        else {
            filteredServices = this.allServices.filter(function (s) {
                var serviceMapEntry = _this.serviceMap[s._id];
                var serviceModeId = serviceMapEntry && serviceMapEntry.mode;
                return serviceModeId === _this.selectedMode ||
                    (serviceModeId && String(serviceModeId) === String(_this.selectedMode));
            });
        }
        if (this.isFallbackSlab && environment.excludedServiceIdsForFallbackSlab) {
            var excludedServiceIds_1 = environment.excludedServiceIdsForFallbackSlab;
            filteredServices = filteredServices.filter(function (service) {
                var serviceId = service.service._id;
                return !excludedServiceIds_1.includes(serviceId);
            });
            // Filter out excluded services from selected service types
            if (this.params.serviceTypes) {
                this.params.serviceTypes = this.params.serviceTypes.filter(function (serviceDetailId) {
                    var serviceDetail = _this.allServices.find(function (s) { return String(s._id) === String(serviceDetailId); });
                    if (!serviceDetail)
                        return true;
                    var serviceId = serviceDetail.service && serviceDetail.service._id ? String(serviceDetail.service._id) : '';
                    return !excludedServiceIds_1.includes(serviceId);
                });
                this.selectedServiceNames = (this.params.serviceTypes || []).map(function (id) { return _this.serviceNames[id] || id; });
                this.servicesChanged();
            }
        }
        // Always assign a new array reference to trigger change detection
        // Sort: active services first, inactive at the bottom
        this.services = (filteredServices || []).sort(function (a, b) {
            if (a.active === b.active && a.service.active === b.service.active) {
                return 0;
            }
            return a.active && a.service.active ? -1 : 1;
        });
    };
    CreateSlabComponent.prototype.fetchDashboardConfig = function () {
        var _this = this;
        this.sharedService.fetchDashboardConfig().toPromise()
            .then(function (res) {
            var payload = _this.sharedService.parseDashboardConfigResponse(res);
            if (payload) {
                _this.dashboardConfig = payload;
                _this.minimumGuaranteeSlotCount = _this.parseMinimumGuaranteeSlotCount(_this.dashboardConfig.minimumGuaranteeSlotCount);
                _this.syncMinimumGuaranteeSlotsInState();
                _this.setEarningModels();
                _this.blockDuplicateFlowIfSlabCategoryNotInConfig();
            }
            else {
                console.warn('[PayrollSlab] fetchDashboardConfig returned no data', res);
            }
        })
            .catch(function (err) { return console.error('[PayrollSlab] fetchDashboardConfig error:', err); });
    };
    // ─────────────────────────────────────────────────────────────
    // City / service / shift handlers
    // ─────────────────────────────────────────────────────────────
    CreateSlabComponent.prototype.onCityChange = function (city) {
        this.clearFlatCommissionDeductions();
        this.defaultShiftsFetchedAndEmpty = false;
        this.shifts = [];
        this.params.shift = [];
        this.oldApiShifts = [];
        this.newApiShifts = [];
        this.selectedMode = null;
        this.selectedModeNames = [];
        this.modes = [];
        this.services = [];
        this.allServices = [];
        this.params.serviceTypes = [];
        this.selectedLayer = null;
        this.layers = [];
        this.layersError = false;
        this.clearExistingGeoSlabs();
        if (!this.isGeoSlabPage && !this.isFetchingShiftsFromSlabEnabled) {
            this.fetchNewShifts(city);
        }
        this.getCityServices(city);
        var cityObj = this.cities.find(function (c) { return c.displayName === city; });
        if (cityObj) {
            this.fetchModesForCity(cityObj._id);
        }
        this.evaluateMinimumGuaranteeState(true);
        this.evaluateFlatCommissionDeductionsState();
        if (this.isGeoSlabPage) {
            this.refreshGeoSlabLayers();
        }
    };
    CreateSlabComponent.prototype.retryGeoSlabLayers = function () {
        this.refreshGeoSlabLayers();
    };
    CreateSlabComponent.prototype.onGeoLayerTypeChange = function () {
        this.selectedLayer = null;
        this.layers = [];
        this.layersError = false;
        this.clearExistingGeoSlabs();
        this.refreshGeoSlabLayers();
    };
    CreateSlabComponent.prototype.onGeoSlabLayerChange = function () {
        this.lookupExistingGeoSlab();
    };
    CreateSlabComponent.prototype.getGeoLayerTypeDisplayName = function () {
        var _this = this;
        var layerType = this.geoLayerTypes.find(function (t) { return t.id === _this.selectedGeoLayerType; });
        return layerType ? layerType.name : (this.selectedGeoLayerType || 'Layer');
    };
    CreateSlabComponent.prototype.getGeoSlabLayerDisplayName = function () {
        var _this = this;
        if (!this.selectedLayer) {
            return '';
        }
        var layer = this.layers.find(function (l) { return String(l.id) === String(_this.selectedLayer); });
        return layer ? layer.name : this.selectedLayer;
    };
    CreateSlabComponent.prototype.getExistingGeoSlabId = function (slab) {
        if (!slab) {
            return '—';
        }
        var id = slab.id || slab._id;
        if (id && typeof id === 'object' && id.$oid) {
            return id.$oid;
        }
        return id != null ? String(id) : '—';
    };
    CreateSlabComponent.prototype.getExistingGeoSlabCity = function (slab) {
        if (slab && Array.isArray(slab.cities) && slab.cities.length) {
            return slab.cities.join(', ');
        }
        return this.selectedCities || '—';
    };
    CreateSlabComponent.prototype.getExistingGeoSlabServiceNames = function (slab) {
        var _this = this;
        if (slab && Array.isArray(slab.serviceNames) && slab.serviceNames.length) {
            return slab.serviceNames.join(', ');
        }
        var ids = (slab && (slab.serviceTypes || slab.serviceDetailIds)) || [];
        if (!ids.length) {
            return (this.selectedServiceNames || []).join(', ') || '—';
        }
        return ids.map(function (id) { return _this.serviceNames[id] || id; }).join(', ');
    };
    CreateSlabComponent.prototype.getExistingGeoSlabShifts = function (slab) {
        var shift = slab && slab.shift;
        if (Array.isArray(shift) && shift.length) {
            return shift.join(', ');
        }
        return shift ? String(shift) : '—';
    };
    CreateSlabComponent.prototype.getExistingGeoSlabHotspot = function (slab) {
        var layerId = slab && (slab.layerId != null ? slab.layerId : slab.geoLayerId);
        if (layerId == null || String(layerId) === '') {
            return '—';
        }
        if (String(layerId) === String(this.selectedLayer)) {
            return this.getGeoSlabLayerDisplayName();
        }
        return String(layerId);
    };
    CreateSlabComponent.prototype.getExistingGeoSlabRadiusValue = function (slab) {
        var details = this.getGeoPickupFareConfig(slab);
        return details.radiusInMeters != null ? details.radiusInMeters : '—';
    };
    CreateSlabComponent.prototype.getExistingGeoSlabAmountValue = function (slab) {
        var details = this.getGeoPickupFareConfig(slab);
        return details.amount != null ? details.amount : '—';
    };
    CreateSlabComponent.prototype.getExistingGeoSlabSections = function (slab) {
        var sections = [
            { key: 'peakSlab', label: 'Peak slab' },
            { key: 'nonPeakSlab', label: 'Non-peak slab' },
            { key: 'flexibleSlab', label: 'Flexible slab' },
            { key: 'nightSlab', label: 'Night slab' }
        ];
        return sections.map(function (section) {
            var rows = (((slab && slab[section.key] && slab[section.key].slabData) || {}).slabs) || [];
            return {
                label: section.label,
                rows: Array.isArray(rows) ? rows.filter(function (row) { return row && (row.fromValue != null || row.toValue != null || row.minPerAmount != null || row.bonus != null); }) : []
            };
        }).filter(function (section) { return section.rows.length > 0; });
    };
    CreateSlabComponent.prototype.getGeoServiceGroupIdsForCurrentSelection = function () {
        var _this = this;
        var sourceServices = (this.params.serviceTypes && this.params.serviceTypes.length > 0)
            ? this.allServices.filter(function (s) { return _this.params.serviceTypes.indexOf(s._id) !== -1; })
            : this.services;
        var groupIds = [];
        var seen = {};
        (sourceServices || []).forEach(function (s) {
            var fromMap = _this.serviceMap[s._id] && _this.serviceMap[s._id].geoServiceGroupId;
            var groupId = fromMap || (s.service && s.service.geoServiceGroupId);
            if (groupId && !seen[groupId]) {
                seen[groupId] = true;
                groupIds.push(groupId);
            }
        });
        return groupIds;
    };
    CreateSlabComponent.prototype.refreshGeoSlabLayers = function () {
        var _this = this;
        var cityObj = this.cities.find(function (c) { return c.displayName === _this.selectedCities; });
        if (!cityObj) {
            this.clearGeoSlabLayers();
            return;
        }
        if (this.selectedGeoLayerType !== 'hotspot' && !this.selectedMode) {
            this.clearGeoSlabLayers();
            return;
        }
        this.fetchGeoSlabLayers(cityObj._id, this.getGeoServiceGroupIdsForCurrentSelection());
    };
    CreateSlabComponent.prototype.clearGeoSlabLayers = function () {
        this.geoLayersRequestId++;
        this.layers = [];
        this.layersLoading = false;
        this.layersError = false;
    };
    CreateSlabComponent.prototype.fetchGeoSlabLayers = function (cityId, groupIds) {
        var _this = this;
        if (groupIds === void 0) { groupIds = []; }
        if (!cityId || !this.selectedGeoLayerType) {
            this.clearGeoSlabLayers();
            return;
        }
        var needsGroupId = this.selectedGeoLayerType === 'zone';
        if (needsGroupId && (!groupIds || groupIds.length === 0)) {
            this.clearGeoSlabLayers();
            return;
        }
        this.layersLoading = true;
        this.layersError = false;
        var requestId = ++this.geoLayersRequestId;
        var categories = this.selectedGeoLayerType === 'hotspot' ? ['Hail'] : [];
        this.sharedService.fetchLayers(cityId, this.selectedGeoLayerType, groupIds, categories).toPromise()
            .then(function (res) {
            if (requestId !== _this.geoLayersRequestId) {
                return;
            }
            var layers = (res && res.layers) || [];
            _this.layers = layers.filter(function (layer) { return layer && layer.active !== false; });
        })
            .catch(function () {
            if (requestId !== _this.geoLayersRequestId) {
                return;
            }
            _this.layers = [];
            _this.layersError = true;
            _this.showError(_this.layersErrorMessage);
        })
            .finally(function () {
            if (requestId !== _this.geoLayersRequestId) {
                return;
            }
            _this.layersLoading = false;
        });
    };
    CreateSlabComponent.prototype.lookupExistingGeoSlab = function () {
        var _this = this;
        if (!this.isGeoSlabPage || !this.selectedCities || !this.selectedLayer || !this.selectedGeoLayerType) {
            this.existingGeoSlabsLoading = false;
            this.existingGeoSlabLookupCount = 0;
            this.clearExistingGeoSlabs();
            return Promise.resolve();
        }
        var cityObj = this.cities.find(function (c) { return c.displayName === _this.selectedCities; });
        var cityId = cityObj && cityObj._id;
        if (!cityId) {
            this.existingGeoSlabsLoading = false;
            this.existingGeoSlabLookupCount = 0;
            this.clearExistingGeoSlabs();
            return Promise.resolve();
        }
        var requestId = ++this.existingGeoSlabLookupId;
        this.existingGeoSlabsLoading = true;
        return this.sharedService.fetchGeoSlabConfig(cityId, this.selectedLayer, this.selectedGeoLayerType).toPromise()
            .then(function (res) {
            if (requestId !== _this.existingGeoSlabLookupId) {
                return;
            }
            var slabId = res && res.data && res.data.slabId;
            if (!slabId) {
                _this.existingGeoSlabLookupCount = 0;
                _this.clearExistingGeoSlabs();
                return;
            }
            return _this.sharedService.getSlab(slabId).toPromise().then(function (slabRes) {
                if (requestId !== _this.existingGeoSlabLookupId) {
                    return;
                }
                var slab = _this.unwrapSlabResponse(slabRes);
                _this.setExistingGeoSlabs(_this.geoFenceSlabMatches(slab) ? [slab] : []);
                _this.existingGeoSlabLookupCount = _this.existingGeoSlabs.length;
                if (_this.existingGeoSlab) {
                    var details = _this.getGeoPickupFareConfig(_this.existingGeoSlab);
                    if (_this.geoFenceRadius == null && details.radiusInMeters != null) {
                        _this.geoFenceRadius = Number(details.radiusInMeters);
                    }
                    if (_this.geoFenceAmount == null && details.amount != null) {
                        _this.geoFenceAmount = Number(details.amount);
                    }
                }
            });
        })
            .catch(function (err) {
            if (requestId !== _this.existingGeoSlabLookupId) {
                return;
            }
            _this.clearExistingGeoSlabs();
            _this.showError('Could not load existing Geo Slabs');
            throw err;
        })
            .then(function () {
            if (requestId !== _this.existingGeoSlabLookupId) {
                return;
            }
            _this.existingGeoSlabsLoading = false;
        }, function (err) {
            if (requestId !== _this.existingGeoSlabLookupId) {
                return Promise.resolve();
            }
            _this.existingGeoSlabsLoading = false;
            return Promise.reject(err);
        });
    };
    CreateSlabComponent.prototype.clearExistingGeoSlabs = function () {
        this.existingGeoSlabs = [];
        this.existingGeoSlab = null;
    };
    CreateSlabComponent.prototype.setExistingGeoSlabs = function (slabs) {
        this.existingGeoSlabs = slabs || [];
        this.existingGeoSlab = this.existingGeoSlabs[0] || null;
    };
    CreateSlabComponent.prototype.unwrapSlabResponse = function (res) {
        var slab = res && res.data != null ? res.data : res;
        if (slab && slab.slab && typeof slab.slab === 'object') {
            slab = slab.slab;
        }
        return slab || null;
    };
    CreateSlabComponent.prototype.geoFenceSlabMatches = function (slab) {
        if (!slab) {
            return false;
        }
        var layerId = slab.layerId != null ? slab.layerId : slab.geoLayerId;
        if (layerId == null || String(layerId) === '') {
            return true;
        }
        return String(layerId) === String(this.selectedLayer);
    };
    CreateSlabComponent.prototype.getGeoPickupFareConfig = function (slab) {
        var config = (slab && (slab.geoFencePickupFareConfig || slab.geoFenceDetails)) || {};
        return {
            radiusInMeters: config.radiusInMeters != null ? config.radiusInMeters : config.radius,
            amount: config.amount
        };
    };
    CreateSlabComponent.prototype.onGeoSlabRadiusKeydown = function (event) {
        var key = event.key;
        if (key && key.length === 1 && key >= '0' && key <= '9') {
            return;
        }
        if (event.ctrlKey || event.metaKey || event.altKey) {
            return;
        }
        var navigationKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
            'ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (navigationKeys.indexOf(key) !== -1) {
            return;
        }
        event.preventDefault();
    };
    CreateSlabComponent.prototype.onGeoSlabRadiusInput = function (event) {
        var input = event.target;
        var digits = (input.value || '').replace(/\D/g, '');
        if (input.value !== digits) {
            input.value = digits;
        }
        this.geoFenceRadius = digits === '' ? null : Number(digits);
    };
    CreateSlabComponent.prototype.applyGeoSlabPayloadFields = function (slab, userEmail) {
        var _this = this;
        var cityObj = this.cities.find(function (c) { return c.displayName === _this.selectedCities; });
        slab.isGeoSlab = true;
        slab.layer = this.selectedGeoLayerType;
        slab.layerId = this.selectedLayer;
        slab.cityId = cityObj && cityObj._id ? cityObj._id : slab.cityId;
        slab.geoFencePickupFareConfig = {
            radiusInMeters: Number(this.geoFenceRadius),
            amount: Number(this.geoFenceAmount)
        };
        slab.createdBy = userEmail || slab.createdBy;
        slab.shift = [];
        delete slab.geoFenceDetails;
        delete slab.radius;
        delete slab.amount;
    };
    CreateSlabComponent.prototype.servicesChanged = function () {
        var _this = this;
        var selected = this.params.serviceTypes || [];
        if (selected.length === 0) {
            this.mode = null;
            this.setEarningModels();
            this.evaluateMinimumGuaranteeState(true);
            this.evaluateFlatCommissionDeductionsState();
            if (this.isGeoSlabPage) {
                this.selectedLayer = null;
                this.layers = [];
                this.clearExistingGeoSlabs();
                this.refreshGeoSlabLayers();
            }
            return;
        }
        var modes = new Set(selected.map(function (id) { return _this.serviceMap[id] && _this.serviceMap[id].mode; }).filter(Boolean));
        if (this.isViewMode) {
            var selectedModeFromServices = modes.size === 1 ? (modes.values().next().value || null) : null;
            if (!this.mode && selectedModeFromServices) {
                this.mode = selectedModeFromServices;
            }
            this.setEarningModels();
            this.evaluateMinimumGuaranteeState(true);
            this.evaluateFlatCommissionDeductionsState();
            return;
        }
        if (modes.size > 1) {
            this.params.serviceTypes = [];
            this.mode = null;
            this.showError('Select services with same mode');
            this.evaluateMinimumGuaranteeState(true);
            this.evaluateFlatCommissionDeductionsState();
            return;
        }
        this.mode = modes.values().next().value || null;
        this.setEarningModels();
        this.applyFallbackSingleShiftSelection();
        this.evaluateMinimumGuaranteeState(true);
        this.blockDuplicateFlowIfSlabCategoryNotInConfig();
        this.evaluateFlatCommissionDeductionsState();
        if (this.isGeoSlabPage) {
            this.selectedLayer = null;
            this.layers = [];
            this.clearExistingGeoSlabs();
            this.refreshGeoSlabLayers();
        }
    };
    CreateSlabComponent.prototype.setEarningModels = function () {
        if (this.actionTitle !== 'View' && this.actionTitle !== 'Duplicate') {
            delete this.params.earningModel;
        }
        var cfg = this.dashboardConfig && this.dashboardConfig.earningModelsForModeAndSlabCategory;
        if (this.mode && this.category && cfg && cfg[this.mode]) {
            this.earningModels = cfg[this.mode][this.category] || [];
        }
        else {
            this.earningModels = [];
        }
        if ((this.isViewMode || this.actionTitle === 'Duplicate') && this.params.earningModel && this.earningModels.indexOf(this.params.earningModel) === -1) {
            this.earningModels = this.earningModels.slice();
            this.earningModels.push(this.params.earningModel);
        }
        if (cfg && cfg[this.mode]) {
            this.categories = Object.keys(cfg[this.mode]);
        }
        this.evaluateMinimumGuaranteeState();
    };
    CreateSlabComponent.prototype.earningModelChanged = function () {
        if (this.params.earningModel && this.params.earningModel === 'access_fee') {
            this.setCommissionAmountToZero();
            this.clearExtraKmFareData();
            this.clearPickUpExtraKmFareData();
        }
        else {
            this.reconcileCommissionFields();
        }
        this.evaluateMinimumGuaranteeState(true);
        this.warnIfMinimumGuaranteeWithMultipleShifts();
        this.evaluateFlatCommissionDeductionsState();
    };
    CreateSlabComponent.prototype.onCommissionTypeChange = function () {
        this.evaluateFlatCommissionDeductionsState();
    };
    CreateSlabComponent.prototype.shouldShowFlatCommissionDeductions = function () {
        if (this.category === 'order') {
            return false;
        }
        var earningModel = this.params && this.params.earningModel;
        if (!earningModel) {
            return false;
        }
        var isFlatCommission = earningModel === 'proximity_flat_commission' ||
            (earningModel === 'cm' && this.params.commissionType === 'rupees');
        if (!isFlatCommission) {
            return false;
        }
        if (this.isViewMode) {
            return this.slabHasCommissionWithAdditionalDeductions;
        }
        return true;
    };
    CreateSlabComponent.prototype.shouldFetchFlatCommissionDeductions = function () {
        var _this = this;
        if (this.isViewMode || !this.shouldShowFlatCommissionDeductions()) {
            return false;
        }
        var cityObj = this.cities.find(function (c) { return c.displayName === _this.selectedCities; });
        var serviceDetailIds = Array.isArray(this.params.serviceTypes)
            ? this.params.serviceTypes.filter(function (id) { return !!id; })
            : [];
        return !!(cityObj && cityObj._id && serviceDetailIds.length > 0);
    };
    CreateSlabComponent.prototype.evaluateFlatCommissionDeductionsState = function () {
        if (!this.shouldFetchFlatCommissionDeductions()) {
            this.clearFlatCommissionDeductions();
            return;
        }
        this.fetchFlatCommissionDeductions();
    };
    CreateSlabComponent.prototype.clearFlatCommissionDeductions = function () {
        this.flatCommissionDeductionsRequestId++;
        this.flatCommissionDeductionsLoading = false;
        this.flatCommissionDeductionsError = false;
        this.flatCommissionTax = null;
        this.flatCommissionPlatformFee = null;
        this.flatCommissionDeductionDetails = [];
        delete this.params.flatCommissionDeductions;
    };
    CreateSlabComponent.prototype.fetchFlatCommissionDeductions = function () {
        var _this = this;
        var cityObj = this.cities.find(function (c) { return c.displayName === _this.selectedCities; });
        var serviceDetailIds = Array.isArray(this.params.serviceTypes)
            ? this.params.serviceTypes.filter(function (id) { return !!id; })
            : [];
        if (!cityObj || !cityObj._id || serviceDetailIds.length === 0) {
            this.clearFlatCommissionDeductions();
            return;
        }
        var requestId = ++this.flatCommissionDeductionsRequestId;
        this.flatCommissionDeductionsLoading = true;
        this.flatCommissionDeductionsError = false;
        this.sharedService.fetchFlatCommissionDeductions({
            cityId: cityObj._id,
            serviceDetailIds: serviceDetailIds,
        }).toPromise()
            .then(function (res) {
            if (requestId !== _this.flatCommissionDeductionsRequestId) {
                return;
            }
            var details = res && Array.isArray(res.details) ? res.details : [];
            _this.flatCommissionDeductionDetails = details;
            _this.flatCommissionTax = details.length > 0
                ? details.reduce(function (max, item) { return Math.max(max, Number(item.tax) || 0); }, 0)
                : null;
            _this.flatCommissionPlatformFee = details.length > 0
                ? details.reduce(function (max, item) { return Math.max(max, Number(item.platformFee) || 0); }, 0)
                : null;
            if (!_this.isViewMode) {
                _this.params.flatCommissionDeductions = {
                    tax: _this.flatCommissionTax,
                    platformFee: _this.flatCommissionPlatformFee,
                    details: details,
                };
            }
        })
            .catch(function () {
            if (requestId !== _this.flatCommissionDeductionsRequestId) {
                return;
            }
            _this.flatCommissionDeductionsError = true;
            _this.flatCommissionTax = null;
            _this.flatCommissionPlatformFee = null;
            _this.flatCommissionDeductionDetails = [];
            delete _this.params.flatCommissionDeductions;
        })
            .finally(function () {
            if (requestId !== _this.flatCommissionDeductionsRequestId) {
                return;
            }
            _this.flatCommissionDeductionsLoading = false;
        });
    };
    Object.defineProperty(CreateSlabComponent.prototype, "flatCommissionTaxDisplay", {
        get: function () {
            return this.flatCommissionTax != null ? String(this.flatCommissionTax) : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateSlabComponent.prototype, "flatCommissionPlatformFeeDisplay", {
        get: function () {
            return this.flatCommissionPlatformFee != null ? String(this.flatCommissionPlatformFee) : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateSlabComponent.prototype, "isSubmitDisabled", {
        get: function () {
            return this.loadingIndicator || !this.hasValidFlatCommissionDeductions();
        },
        enumerable: true,
        configurable: true
    });
    CreateSlabComponent.prototype.hasValidFlatCommissionDeductions = function () {
        if (!this.shouldShowFlatCommissionDeductions()) {
            return true;
        }
        if (this.flatCommissionDeductionsLoading || this.flatCommissionDeductionsError) {
            return false;
        }
        return this.flatCommissionTax != null && this.flatCommissionPlatformFee != null;
    };
    CreateSlabComponent.prototype.validateFlatCommissionDeductions = function () {
        if (!this.shouldShowFlatCommissionDeductions()) {
            return;
        }
        if (this.flatCommissionDeductionsLoading) {
            this.toastError('Tax and platform fee details are still loading. Please wait.');
        }
        if (this.flatCommissionDeductionsError) {
            this.toastError(this.fetchTaxesAndOrPlatformFeeErrorMessage);
        }
        if (this.flatCommissionTax == null || this.flatCommissionPlatformFee == null) {
            this.toastError('Tax and platform fee details are required.');
        }
    };
    CreateSlabComponent.prototype.onShiftChange = function () {
        this.evaluateMinimumGuaranteeState(true);
        this.warnIfMinimumGuaranteeWithMultipleShifts();
    };
    CreateSlabComponent.prototype.validateEarningModel = function () {
        if (this.earningModels.length > 0 && !this.params.earningModel) {
            this.toastError('Please select Earning Model');
        }
    };
    CreateSlabComponent.prototype.AreWeekDayAndEndDateRemoved = function (city, createdOn, screenAction) {
        if (screenAction && screenAction === 'Duplicate') {
            createdOn = new Date().getTime();
        }
        if (!createdOn) {
            createdOn = new Date().getTime();
        }
        if (!this.dashboardConfig || !this.dashboardConfig.cities_where_weekdaysAndEndDateAreRemoved) {
            return false;
        }
        var cityObj = this.cities.find(function (c) { return c.displayName === city; });
        var cityId = cityObj ? cityObj._id : '';
        var cfg = this.dashboardConfig.cities_where_weekdaysAndEndDateAreRemoved;
        return (cfg.hasOwnProperty(cityId) && cfg[cityId] < createdOn) ||
            (cfg.hasOwnProperty('others') && cfg['others'] < createdOn);
    };
    CreateSlabComponent.prototype.showRupeesCommission = function () {
        var model = this.params && this.params.earningModel;
        var types = model && this.dashboardConfig && this.dashboardConfig.commissionTypesForEarningModels
            ? this.dashboardConfig.commissionTypesForEarningModels[model]
            : null;
        return Array.isArray(types) && types.indexOf('rupees') !== -1;
    };
    CreateSlabComponent.prototype.showPercentCommission = function () {
        var model = this.params && this.params.earningModel;
        var types = model && this.dashboardConfig && this.dashboardConfig.commissionTypesForEarningModels
            ? this.dashboardConfig.commissionTypesForEarningModels[model]
            : null;
        return Array.isArray(types) && types.indexOf('percent') !== -1;
    };
    CreateSlabComponent.prototype.reconcileCommissionFields = function () {
        var _this = this;
        if (this.params && this.params.earningModel === 'access_fee') {
            return;
        }
        var allowPercent = this.showPercentCommission();
        var allowRupees = this.showRupeesCommission();
        var allKeys = [
            'commissionType', 'commissionAmount', 'commissionOnBonus',
            'commissionTypeBatchedFirstOrder', 'commissionAmountBatchedFirstOrder', 'commissionOnBonusBatchedFirstOrder',
            'commissionTypeBatchedNextOrder', 'commissionAmountBatchedNextOrder', 'commissionOnBonusBatchedNextOrder',
        ];
        if (!allowPercent && !allowRupees) {
            allKeys.forEach(function (k) { return delete _this.params[k]; });
            return;
        }
        var groups = [
            ['commissionType', 'commissionAmount', 'commissionOnBonus'],
            ['commissionTypeBatchedFirstOrder', 'commissionAmountBatchedFirstOrder', 'commissionOnBonusBatchedFirstOrder'],
            ['commissionTypeBatchedNextOrder', 'commissionAmountBatchedNextOrder', 'commissionOnBonusBatchedNextOrder'],
        ];
        for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
            var _a = groups_1[_i], typeKey = _a[0], amountKey = _a[1], bonusKey = _a[2];
            var type = this.params[typeKey];
            if (type === 'percent' && !allowPercent) {
                delete this.params[typeKey];
                delete this.params[amountKey];
                delete this.params[bonusKey];
            }
            else if (type === 'rupees' && !allowRupees) {
                delete this.params[typeKey];
                delete this.params[amountKey];
                delete this.params[bonusKey];
            }
        }
    };
    CreateSlabComponent.prototype.clearBatchedSlabData = function () {
        var _this = this;
        var keys = [
            'peakSlabBatchedFirstOrder', 'peakSlabBatchedNextOrder',
            'nonPeakSlabBatchedFirstOrder', 'nonPeakSlabBatchedNextOrder',
            'flexibleSlabBatchedFirstOrder', 'flexibleSlabBatchedNextOrder',
            'nightSlabBatchedFirstOrder', 'nightSlabBatchedNextOrder',
            'commissionAmountBatchedFirstOrder', 'commissionAmountBatchedNextOrder',
            'commissionTypeBatchedFirstOrder', 'commissionTypeBatchedNextOrder',
            'commissionOnBonusBatchedFirstOrder', 'commissionOnBonusBatchedNextOrder',
            'isSurgeIncludedBatchedFirstOrder', 'isSurgeIncludedBatchedNextOrder'
        ];
        keys.forEach(function (k) { return delete _this.params[k]; });
    };
    CreateSlabComponent.prototype.clearPickUpExtraKmFareData = function () {
        this.thresholdDistanceFM = null;
        this.thresholdFareFM = null;
        this.minCompensationFM = null;
        this.maxCompensationFM = null;
    };
    CreateSlabComponent.prototype.clearExtraKmFareData = function () {
        this.thresholdDistanceLM = null;
        this.thresholdFareLM = null;
    };
    CreateSlabComponent.prototype.clearTimeBasedSlabData = function () {
        this.timeBasedSlabs = [];
        delete this.params.timeBasedSlabs;
    };
    CreateSlabComponent.prototype.clearMinimumPayoutData = function () {
        delete this.params.minimumPayout;
    };
    CreateSlabComponent.prototype.setSubSlabstoEmpty = function () {
        this.params.peakSlab = { timeData: [{}], slabData: { slabs: [{}] } };
        this.params.nonPeakSlab = { timeData: [{}], slabData: { slabs: [{}] } };
        this.params.flexibleSlab = { timeData: [{}], slabData: { slabs: [{}] } };
        this.params.nightSlab = { timeData: [{}], slabData: { slabs: [{}] } };
    };
    CreateSlabComponent.prototype.setCommissionAmountToZero = function () {
        this.params.commissionType = 'percent';
        this.params.commissionAmount = 0;
    };
    CreateSlabComponent.prototype.clearSlabData = function (type) {
        switch (type) {
            case 'distance':
                this.clearBatchedSlabData();
                this.setCommissionAmountToZero();
                // Only peak slab for distance; hardcode to full day
                this.params.peakSlab = { timeData: [{ fromTime: '00:00', toTime: '23:59' }], slabData: { slabs: [{}] } };
                delete this.params.nonPeakSlab;
                delete this.params.flexibleSlab;
                delete this.params.nightSlab;
                break;
            case 'cm':
                this.clearBatchedSlabData();
                this.clearExtraKmFareData();
                this.clearTimeBasedSlabData();
                this.clearMinimumPayoutData();
                this.setSubSlabstoEmpty();
                break;
            case 'order':
                this.clearTimeBasedSlabData();
                this.clearMinimumPayoutData();
                break;
            case 'minimum_guarantee':
                this.clearBatchedSlabData();
                this.clearTimeBasedSlabData();
                this.clearMinimumPayoutData();
                this.setSubSlabstoEmpty();
                break;
        }
        this.setEarningModels();
    };
    CreateSlabComponent.prototype.dismissMinimumGuaranteeBanner = function () {
        if (this.currentMinimumGuaranteeContextKey) {
            this.minimumGuaranteeBannerDismissedByContext[this.currentMinimumGuaranteeContextKey] = true;
        }
        this.showMinimumGuaranteeBanner = false;
    };
    CreateSlabComponent.prototype.addMinimumGuaranteeSlot = function () {
        if (this.isViewMode || this.isMinimumGuaranteeReadOnly || this.isMinimumGuaranteeSlotTimeLocked()) {
            return;
        }
        this.ensureMinimumGuaranteeDetailsObject(false);
        var maxSlots = this.minimumGuaranteeSlotCount;
        var slots = this.params.minimumGuaranteeDetails.slots || [];
        if (slots.length >= maxSlots) {
            this.showError("You can add at most " + maxSlots + " Minimum Guarantee time slot" + (maxSlots === 1 ? '' : 's') + " " +
                "(configured limit). Remove a slot or adjust configuration if you need more.");
            return;
        }
        this.params.minimumGuaranteeDetails.slots.push({ startTime: '', endTime: '' });
    };
    CreateSlabComponent.prototype.removeMinimumGuaranteeSlot = function (index) {
        if (this.isViewMode || this.isMinimumGuaranteeReadOnly || this.isMinimumGuaranteeSlotTimeLocked()) {
            return;
        }
        this.ensureMinimumGuaranteeDetailsObject(false);
        var slots = this.params.minimumGuaranteeDetails.slots;
        if (!Array.isArray(slots) || slots.length === 0) {
            return;
        }
        if (slots.length <= 1) {
            this.showError('At least one Minimum Guarantee time slot is required.');
            return;
        }
        slots.splice(index, 1);
    };
    CreateSlabComponent.prototype.addSlabTime = function (slabType) {
        if (!this.params[slabType]) {
            this.params[slabType] = { timeData: [{}], slabData: { slabs: [{}] } };
        }
        if (!this.params[slabType].timeData) {
            this.params[slabType].timeData = [];
        }
        this.params[slabType].timeData.push({});
    };
    CreateSlabComponent.prototype.addSlabData = function (slabType) {
        if (!this.params[slabType]) {
            this.params[slabType] = { timeData: [{}], slabData: { slabs: [{}] } };
        }
        if (!this.params[slabType].slabData) {
            this.params[slabType].slabData = { slabs: [] };
        }
        if (!this.params[slabType].slabData.slabs) {
            this.params[slabType].slabData.slabs = [];
        }
        for (var _i = 0, _a = this.params[slabType].slabData.slabs; _i < _a.length; _i++) {
            var item = _a[_i];
            if (this.isEmpty(item.toValue) || this.isEmpty(item.fromValue) || this.isEmpty(item.minPerAmount)) {
                this.showError('Please enter complete data first');
                return;
            }
        }
        var newSlabIndex = this.params[slabType].slabData.slabs.length;
        this.params[slabType].slabData.slabs.push({ slabTitle: newSlabIndex });
        if (this.category === 'order' && this.params[slabType].slabData.slabs.length > 0) {
            var slabs = this.params[slabType].slabData.slabs;
            slabs[slabs.length - 1].minPerAmount = slabs[0].minPerAmount;
        }
    };
    CreateSlabComponent.prototype.removeDataFromSlab = function (slabType, dataType, index) {
        if (dataType === 'time') {
            this.params[slabType].timeData = this.params[slabType].timeData.filter(function (_, i) { return i !== index; });
        }
        else if (dataType === 'slab' && this.params[slabType].slabData.slabs.length > 0) {
            this.params[slabType].slabData.slabs.pop();
        }
        else {
            this.showError("No " + slabType + " slabs to remove");
        }
    };
    CreateSlabComponent.prototype.updateMinPerAmount = function (slab, value) {
        if (slab === 'peak') {
            this.params.peakSlab.slabData.slabs.forEach(function (item) {
                item.minPerAmount = value;
            });
        }
    };
    CreateSlabComponent.prototype.updateMinPerAmountBatched = function (slabType, value) {
        if (slabType === 'peak') {
            this.params.peakSlabBatchedFirstOrder.slabData.slabs.forEach(function (item) {
                item.minPerAmount = value;
            });
        }
    };
    CreateSlabComponent.prototype.updateMinPerAmount2 = function (slabName, _slab, value) {
        // propagate per-order value to all slabs in a batched section
        if (this.params[slabName] && this.params[slabName].slabData) {
            this.params[slabName].slabData.slabs.forEach(function (item) {
                item.minPerAmount = value;
            });
        }
    };
    // ─────────────────────────────────────────────────────────────
    // Time-based slab management (distance category)
    // ─────────────────────────────────────────────────────────────
    CreateSlabComponent.prototype.addTimeBasedSlab = function () {
        if (this.timeBasedSlabs.length >= 1) {
            this.toastError('Only one timeBasedSlab can be configured');
            return;
        }
        this.timeBasedSlabs.push({ startTime: null, endTime: null, rules: [{ type: 'percentage', value: null }] });
    };
    CreateSlabComponent.prototype.removeTimeBasedSlab = function (index) {
        this.timeBasedSlabs.splice(index, 1);
    };
    // Validation helpers
    CreateSlabComponent.prototype.isEmpty = function (value) {
        return value == null || value === '' || (Array.isArray(value) && value.length === 0);
    };
    CreateSlabComponent.prototype.checkDuplicateInObject = function (propertyName, inputArray) {
        var testObject = {};
        var seenDuplicate = false;
        inputArray.forEach(function (item) {
            var key = item[propertyName];
            if (key in testObject) {
                testObject[key].duplicate = true;
                item.duplicate = true;
                seenDuplicate = true;
            }
            else {
                testObject[key] = item;
                delete item.duplicate;
            }
        });
        return seenDuplicate;
    };
    CreateSlabComponent.prototype.fixTimes = function (slabArray) {
        var _this = this;
        if (slabArray && slabArray.timeData && slabArray.timeData.length > 0) {
            slabArray.timeData.forEach(function (t) {
                // Ensure times are in 24-hour format (HH:mm)
                t.fromTime = _this.ensure24HourFormat(t.fromTime) || 'null';
                t.toTime = _this.ensure24HourFormat(t.toTime) || 'null';
            });
        }
    };
    CreateSlabComponent.prototype.convertTo24Hour = function (time) {
        if (!time || time === 'null') {
            return time;
        }
        var trimmed = time.trim().toUpperCase();
        // Check if it contains AM/PM (shouldn't happen with HTML5 time inputs, but handle it)
        if (trimmed.includes('AM') || trimmed.includes('PM')) {
            var hasAM = trimmed.includes('AM');
            var hasPM = trimmed.includes('PM');
            var timePart = trimmed.replace(/\s*(AM|PM)\s*/i, '');
            var parts_1 = timePart.split(':');
            if (parts_1.length >= 2) {
                var hours = parseInt(parts_1[0], 10);
                var minutes = parts_1[1].replace(/\D/g, '').padStart(2, '0');
                if (hasPM) {
                    if (hours !== 12) {
                        hours += 12;
                    }
                }
                else if (hasAM) {
                    if (hours === 12) {
                        hours = 0;
                    }
                }
                var result = String(hours).padStart(2, '0') + ":" + minutes;
                return result;
            }
        }
        // HTML5 time inputs should return 24-hour format automatically
        // However, if the browser is somehow returning 12-hour format values,
        // we need to detect and convert them
        // Strip seconds if present and ensure proper formatting
        var parts = trimmed.split(':');
        if (parts.length >= 2) {
            var hours = parseInt(parts[0].replace(/\D/g, ''), 10);
            var minutes = parts[1].replace(/\D/g, '').padStart(2, '0');
            // If hours is 1-12 and the original string might have been PM,
            // we can't tell without AM/PM indicator, so trust the browser's value
            // HTML5 time inputs should always return correct 24-hour format
            var result = String(hours).padStart(2, '0') + ":" + minutes;
            return result;
        }
        return trimmed.length > 5 ? trimmed.substring(0, 5) : trimmed;
    };
    CreateSlabComponent.prototype.ensure24HourFormat = function (time) {
        return this.convertTo24Hour(time);
    };
    CreateSlabComponent.prototype.timeDataValidation = function (slabArray) {
        if (slabArray && slabArray.timeData && slabArray.timeData.length !== 0) {
            slabArray.timeData = slabArray.timeData.filter(function (slab) {
                var keys = Object.keys(slab);
                return keys.includes('fromTime') && keys.includes('toTime');
            });
        }
    };
    CreateSlabComponent.prototype.removeEmptyTimeData = function (slabArray) {
        if (slabArray && slabArray.timeData) {
            slabArray.timeData = slabArray.timeData.filter(function (slab) { return Object.keys(slab).length > 0; });
        }
    };
    CreateSlabComponent.prototype.slabDataValidation = function (slabArray) {
        var _this = this;
        if (slabArray && slabArray.slabData && slabArray.slabData.slabs && slabArray.slabData.slabs.length !== 0) {
            slabArray.slabData.category = this.category;
            slabArray.slabData.slabs = slabArray.slabData.slabs.reduce(function (acc, slab) {
                var hasAnyData = !_this.isEmpty(slab.fromValue) || !_this.isEmpty(slab.toValue) ||
                    !_this.isEmpty(slab.minPerAmount) || !_this.isEmpty(slab.slabTitle) ||
                    !_this.isEmpty(slab.bonus);
                // If slab has any data, keep it for validation (validateForEmptyValues will catch missing fields)
                // Only filter out if it's completely empty
                if (hasAnyData) {
                    if (!slab.slabType) {
                        slab.slabType = 'perUnitPay';
                    }
                    if (slab.bonus === undefined || slab.bonus === null) {
                        slab.bonus = 0;
                    }
                    acc.push(slab);
                }
                return acc;
            }, []);
        }
    };
    CreateSlabComponent.prototype.validateForEmptyValues = function (slabArray, type) {
        var _this = this;
        if (slabArray && slabArray.slabData && slabArray.slabData.slabs) {
            slabArray.timeData.forEach(function (data) {
                if (data.fromTime > data.toTime) {
                    _this.toastError("From time is greater than to time in a " + type + " slab");
                }
            });
            slabArray.slabData.slabs.forEach(function (item) {
                if (_this.isEmpty(item.toValue) || _this.isEmpty(item.fromValue) || item.toValue < 0 || item.fromValue < 0) {
                    _this.toastError("From and To values cannot be empty or negative at " + type + " slab: " + item.slabTitle);
                }
                if (item.toValue < item.fromValue) {
                    _this.toastError("'From' cannot be greater than 'To' at " + type + " slab: " + item.slabTitle);
                }
                if (!Number.isInteger(item.toValue) || !Number.isInteger(item.fromValue)) {
                    _this.toastError("Non integer values are not allowed at " + type + " slab: " + item.slabTitle);
                }
                if (!item.minPerAmount || item.minPerAmount < 0 || isNaN(item.minPerAmount)) {
                    _this.toastError("Per KM/Per Order is either empty or not a positive-integer value at " + type + " slab: " + item.slabTitle);
                }
                if (item.bonus < 0 || !Number.isInteger(item.bonus)) {
                    _this.toastError("Bonus is negative or a non-integer value at " + type + " slab: " + item.slabTitle);
                }
            });
        }
    };
    CreateSlabComponent.prototype.validateCategoryForSlab = function (slabArray, type) {
        if (slabArray && slabArray.slabData && slabArray.slabData.slabs.length > 0 && !slabArray.slabData.category) {
            this.toastError("Category not provided for " + type + " slab");
        }
    };
    CreateSlabComponent.prototype.validateTimeAndSlabData = function (slabArray, type) {
        if (slabArray &&
            slabArray.timeData.length === 0 && slabArray.slabData.slabs.length > 0) {
            this.toastError("Time data is mandatory for " + type + " slab");
        }
    };
    CreateSlabComponent.prototype.deleteSlabDataIfEmpty = function (slabArray, type) {
        if (slabArray && slabArray.slabData && slabArray.slabData.slabs.length === 0) {
            this.toasterService.showToaster(new Toaster({ type: ToasterType.NOTIFICATION, message: "No " + type + " data" }));
            delete this.finalSlabData[type];
        }
    };
    CreateSlabComponent.prototype.validateDuplicateTimeIntervals = function (slabArray, type) {
        if (slabArray && slabArray.timeData && slabArray.timeData.length > 0) {
            var times_1 = [];
            slabArray.timeData = slabArray.timeData.reduce(function (acc, item) {
                times_1.push({ time: item.fromTime }, { time: item.toTime });
                acc.push({ fromTime: item.fromTime, toTime: item.toTime });
                return acc;
            }, []);
            if (this.checkDuplicateInObject('time', times_1)) {
                this.toastError("Duplicate or blank values found for time data in " + type + " Slab. Please fix.");
            }
        }
    };
    CreateSlabComponent.prototype.validateCommonFields = function () {
        var _this = this;
        this.loadingIndicator = true;
        this.params.payrollVersion = 2.0;
        this.finalSlabData = this.params;
        this.persistValues = JSON.parse(JSON.stringify(this.params));
        if (!this.selectedCities || this.selectedCities.length === 0) {
            this.toastError('City is missing');
        }
        if (!this.params.serviceTypes || this.params.serviceTypes.length === 0) {
            this.toastError('Service(s) is missing');
        }
        this.selectedServiceNames = (this.params.serviceTypes || []).map(function (id) { return _this.serviceNames[id]; });
        if (!this.isGeoSlabPage && (!this.params.shift || this.params.shift.length === 0)) {
            this.toastError('Shift(s) is missing');
        }
        if (this.isGeoSlabPage && !this.selectedGeoLayerType) {
            this.toastError('Please select a layer');
        }
        if (this.isGeoSlabPage && !this.selectedLayer) {
            this.toastError('Please select a ' + this.getGeoLayerTypeDisplayName().toLowerCase());
        }
        if (this.isGeoSlabPage) {
            if (this.geoFenceRadius == null || this.geoFenceRadius === '' || isNaN(Number(this.geoFenceRadius)) || Number(this.geoFenceRadius) <= 0) {
                this.toastError('Please enter a valid radius greater than 0');
            }
            if (this.geoFenceAmount == null || this.geoFenceAmount === '' || isNaN(Number(this.geoFenceAmount)) || Number(this.geoFenceAmount) < 0) {
                this.toastError('Please enter a valid amount');
            }
        }
        if (!this.isGeoSlabPage && this.isMinimumGuaranteeEarningModel() && this.getSelectedShiftCount() > 1) {
            this.toastError('Minimum Guarantee earning model allows only one shift. Remove extra shifts before creating this slab.');
        }
        if (!this.params.startDate) {
            this.toastError('Start date is missing');
        }
        if (this.params.startDate && moment(this.params.startDate, 'YYYY-MM-DD') < moment().startOf('day')) {
            this.toastError('Start date cannot be in the past');
        }
        this.params.startDate = this.formatDate(this.params.startDate);
        delete this.params.endDate;
    };
    CreateSlabComponent.prototype.validateCategorySelected = function () {
        if (!this.category) {
            this.toastError('Please select a category for all slabs');
        }
    };
    CreateSlabComponent.prototype.validateFistMileFields = function () {
        if (!this.isEmpty(this.thresholdFareFM) && this.isEmpty(this.thresholdDistanceFM)) {
            this.toastError('Please fill first mile threshold distance');
        }
        if (this.isEmpty(this.thresholdFareFM) && !this.isEmpty(this.thresholdDistanceFM)) {
            this.toastError('Please fill last mile threshold Fare');
        }
        if (!this.isEmpty(this.thresholdDistanceFM) || !this.isEmpty(this.thresholdFareFM)) {
            if (this.isEmpty(this.maxCompensationFM) || this.maxCompensationFM < 0 || this.maxCompensationFM > 99) {
                this.toastError('Please enter a positive Max Compensation less than 100');
            }
            if (this.isEmpty(this.minCompensationFM) || this.minCompensationFM < 0 || this.minCompensationFM > 99) {
                this.toastError('Please enter a positive Min Compensation less than 100');
            }
            if (this.minCompensationFM > this.maxCompensationFM) {
                this.toastError('The minimum compensation amount should be lesser than the maximum FM compensation amount');
            }
            if (this.minCompensationFM > this.thresholdFareFM) {
                this.toastError('The minimum compensation amount should be lesser than the FM threshold amount');
            }
        }
    };
    CreateSlabComponent.prototype.validateLastMileFields = function () {
        if (!this.isEmpty(this.thresholdFareLM) && this.isEmpty(this.thresholdDistanceLM)) {
            this.toastError('Please fill last mile threshold distance');
        }
    };
    CreateSlabComponent.prototype.validateCommission = function () {
        this.reconcileCommissionFields();
        if (!this.showPercentCommission() &&
            !this.showRupeesCommission()) {
            return;
        }
        if (this.actionTitle === 'Add' ||
            (this.actionTitle === 'Edit' &&
                ((this.category === 'order' && !this.isBatchedOrder) || this.category !== 'order'))) {
            if (!this.params.commissionType) {
                this.toastError('Please select a commission type');
            }
            if (this.params.commissionType === 'percent') {
                this.params.commissionOnBonus = true;
            }
            if (this.isEmpty(this.params.commissionAmount)) {
                this.toastError('Please enter a commission amount');
            }
            if (!this.isEmpty(this.params.commissionAmount) && this.params.commissionAmount < 0) {
                this.toastError('Commission amount cannot be negative');
            }
        }
        if (this.category === 'order' &&
            ((this.actionTitle === 'Add' || this.actionTitle === 'Duplicate') ||
                (this.actionTitle === 'Edit' && this.isBatchedOrder === true))) {
            if (!this.params.commissionTypeBatchedFirstOrder) {
                this.toastError('Please select a commission type for first batched order');
            }
            if (!this.params.commissionTypeBatchedNextOrder) {
                this.toastError('Please select a commission type for next batched order');
            }
            if (!this.BatchedFirstOrderCategory) {
                this.toastError('Please select a category for batched first order slab');
            }
            if (!this.BatchedNextOrderCategory) {
                this.toastError('Please select a category for batched next order slab');
            }
            if (this.params.commissionTypeBatchedFirstOrder === 'percent') {
                this.params.commissionOnBonusBatchedFirstOrder = true;
            }
            if (this.params.commissionTypeBatchedNextOrder === 'percent') {
                this.params.commissionOnBonusBatchedNextOrder = true;
            }
            if (this.isEmpty(this.params.commissionAmountBatchedFirstOrder)) {
                this.toastError('Please enter a commission amount for batched first order');
            }
            if (this.isEmpty(this.params.commissionAmountBatchedNextOrder)) {
                this.toastError('Please enter a commission amount for batched next order');
            }
            if (!this.isEmpty(this.params.commissionAmountBatchedFirstOrder) && this.params.commissionAmountBatchedFirstOrder < 0) {
                this.toastError('Commission amount for Batched first order cannot be negative');
            }
            if (!this.isEmpty(this.params.commissionAmountBatchedNextOrder) && this.params.commissionAmountBatchedNextOrder < 0) {
                this.toastError('Commission amount for Batched next order cannot be negative');
            }
        }
    };
    CreateSlabComponent.prototype.validateSlabs = function () {
        var _this = this;
        if (this.category === 'cm') {
            this.params.peakSlab = {
                slabData: {
                    category: 'cm',
                    slabs: [{ slabTitle: 'slab-0', slabType: 'cm', minPerAmount: 0, toValue: 9999, fromValue: 0 }]
                },
                timeData: [{ toTime: '23:59', fromTime: '00:00' }]
            };
            delete this.params.nonPeakSlab;
            delete this.params.flexibleSlab;
            delete this.params.nightSlab;
        }
        else if ((this.category === 'order' || this.category === 'distance') &&
            ((this.actionTitle === 'Add' || this.actionTitle === 'Duplicate') || this.isBatchedOrder === false)) {
            if (this.category === 'distance') {
                delete this.params.nonPeakSlab;
                delete this.params.flexibleSlab;
                delete this.params.nightSlab;
            }
            var slabTypes = this.category === 'distance'
                ? ['peakSlab']
                : ['peakSlab', 'nonPeakSlab', 'flexibleSlab', 'nightSlab'];
            slabTypes.forEach(function (slabType) {
                if (_this.params[slabType] && _this.params[slabType].slabData && _this.params[slabType].slabData.slabs) {
                    _this.params[slabType].slabData.slabs.forEach(function (slab, index) {
                        if (slab.slabTitle === undefined || slab.slabTitle === null || slab.slabTitle === '') {
                            slab.slabTitle = index;
                        }
                        slab.slabTitle = "" + slab.slabTitle;
                        if (!slab.slabTitle.includes('slab-')) {
                            slab.slabTitle = "slab-" + slab.slabTitle;
                        }
                    });
                }
                _this.timeDataValidation(_this.params[slabType]);
                _this.slabDataValidation(_this.params[slabType]);
                _this.removeEmptyTimeData(_this.params[slabType]);
                _this.validateForEmptyValues(_this.params[slabType], slabType);
                _this.validateCategoryForSlab(_this.params[slabType], slabType);
                _this.validateDuplicateTimeIntervals(_this.params[slabType], slabType);
                _this.validateTimeAndSlabData(_this.params[slabType], slabType);
                _this.deleteSlabDataIfEmpty(_this.params[slabType], slabType);
                _this.fixTimes(_this.params[slabType]);
            });
        }
        if (this.category === 'order' &&
            ((this.actionTitle === 'Add' || this.actionTitle === 'Duplicate') || this.isBatchedOrder === true)) {
            var batchedTypes = [
                'peakSlabBatchedFirstOrder', 'nonPeakSlabBatchedFirstOrder',
                'flexibleSlabBatchedFirstOrder', 'nightSlabBatchedFirstOrder',
                'peakSlabBatchedNextOrder', 'nonPeakSlabBatchedNextOrder',
                'flexibleSlabBatchedNextOrder', 'nightSlabBatchedNextOrder'
            ];
            batchedTypes.forEach(function (slabType) {
                if (_this.params[slabType] && _this.params[slabType].slabData && _this.params[slabType].slabData.slabs) {
                    _this.params[slabType].slabData.slabs.forEach(function (slab, index) {
                        if (slab.slabTitle === undefined || slab.slabTitle === null || slab.slabTitle === '') {
                            slab.slabTitle = index;
                        }
                        slab.slabTitle = "" + slab.slabTitle;
                        if (!slab.slabTitle.includes('slab-')) {
                            slab.slabTitle = "slab-" + slab.slabTitle;
                        }
                    });
                }
                _this.timeDataValidation(_this.params[slabType]);
                _this.slabDataValidation(_this.params[slabType]);
                _this.removeEmptyTimeData(_this.params[slabType]);
                _this.validateForEmptyValues(_this.params[slabType], slabType);
                _this.validateCategoryForSlab(_this.params[slabType], slabType);
                _this.validateDuplicateTimeIntervals(_this.params[slabType], slabType);
                _this.validateTimeAndSlabData(_this.params[slabType], slabType);
                _this.deleteSlabDataIfEmpty(_this.params[slabType], slabType);
                _this.fixTimes(_this.params[slabType]);
            });
        }
        if (this.category === 'order' &&
            ((this.actionTitle === 'Add' || this.actionTitle === 'Duplicate') ||
                (this.actionTitle === 'Edit' && this.isBatchedOrder === true))) {
            if (this.isEmpty(this.params.peakSlabBatchedFirstOrder) &&
                this.isEmpty(this.params.nonPeakSlabBatchedFirstOrder) &&
                this.isEmpty(this.params.flexibleSlabBatchedFirstOrder) &&
                this.isEmpty(this.params.nightSlabBatchedFirstOrder)) {
                this.toastError('Please fill in the batch order slab details');
            }
            if (this.isEmpty(this.params.peakSlabBatchedNextOrder) &&
                this.isEmpty(this.params.nonPeakSlabBatchedNextOrder) &&
                this.isEmpty(this.params.flexibleSlabBatchedNextOrder) &&
                this.isEmpty(this.params.nightSlabBatchedNextOrder)) {
                this.toastError('Please fill in the batch order slab details');
            }
            this.params.batchDetails = {};
            var batchedFirstOrder = {
                peakSlab: this.params.peakSlabBatchedFirstOrder,
                nonPeakSlab: this.params.nonPeakSlabBatchedFirstOrder,
                flexibleSlab: this.params.flexibleSlabBatchedFirstOrder,
                nightSlab: this.params.nightSlabBatchedFirstOrder,
                commissionAmount: this.params.commissionAmountBatchedFirstOrder.toString(),
                commissionType: this.params.commissionTypeBatchedFirstOrder,
                commissionOnBonus: this.params.commissionOnBonusBatchedFirstOrder,
                thresholdDistanceFM: this.thresholdDistanceFM,
                thresholdDistanceLM: this.thresholdDistanceLM,
                thresholdFareFM: this.thresholdFareFM,
                thresholdFareLM: this.thresholdFareLM,
                maxCompensationFM: this.maxCompensationFM,
                minCompensationFM: this.minCompensationFM,
                isSurgeIncluded: true
            };
            this.params.batchDetails.firstOrder = batchedFirstOrder;
            ['peakSlabBatchedFirstOrder', 'nonPeakSlabBatchedFirstOrder', 'flexibleSlabBatchedFirstOrder',
                'nightSlabBatchedFirstOrder', 'commissionAmountBatchedFirstOrder', 'commissionTypeBatchedFirstOrder',
                'commissionOnBonusBatchedFirstOrder'].forEach(function (k) { return delete _this.params[k]; });
            var batchedNextOrder = {
                peakSlab: this.params.peakSlabBatchedNextOrder,
                nonPeakSlab: this.params.nonPeakSlabBatchedNextOrder,
                flexibleSlab: this.params.flexibleSlabBatchedNextOrder,
                nightSlab: this.params.nightSlabBatchedNextOrder,
                commissionAmount: this.params.commissionAmountBatchedNextOrder.toString(),
                commissionType: this.params.commissionTypeBatchedNextOrder,
                commissionOnBonus: this.params.commissionOnBonusBatchedNextOrder,
                thresholdDistanceLM: this.thresholdDistanceLM,
                thresholdFareLM: this.thresholdFareLM,
                isSurgeIncluded: true
            };
            this.params.batchDetails.nextOrder = batchedNextOrder;
            ['peakSlabBatchedNextOrder', 'nonPeakSlabBatchedNextOrder', 'flexibleSlabBatchedNextOrder',
                'nightSlabBatchedNextOrder', 'commissionAmountBatchedNextOrder', 'commissionTypeBatchedNextOrder',
                'commissionOnBonusBatchedNextOrder'].forEach(function (k) { return delete _this.params[k]; });
        }
        // Mirrors Rapido Dashboard UI: if((actionTitle=='Add'||actionTitle=='Duplicate') || (!isBatchedOrder))
        if ((this.actionTitle === 'Add' || this.actionTitle === 'Duplicate') || !this.isBatchedOrder) {
            if (this.category === 'distance') {
                // For distance category, only peak slab is required
                if (this.isEmpty(this.params.peakSlab)) {
                    this.toastError('Please fill in the slab details');
                }
            }
            else {
                // For order category, check all slabs
                if (this.isEmpty(this.params.peakSlab) && this.isEmpty(this.params.nonPeakSlab) &&
                    this.isEmpty(this.params.flexibleSlab) && this.isEmpty(this.params.nightSlab)) {
                    this.toastError('Please fill in the slab details');
                }
            }
        }
    };
    CreateSlabComponent.prototype.submitSlab = function () {
        var _this = this;
        try {
            this.validateCommonFields();
            this.validateCategorySelected();
            this.validateEarningModel();
            this.validateFistMileFields();
            this.validateLastMileFields();
            this.validateMinimumGuaranteeDetails();
            this.validatePoolSlab();
            // Copy timeBasedSlabs into params for distance category
            if (this.category === 'distance') {
                if (this.timeBasedSlabs.length > 0) {
                    this.params.timeBasedSlabs = this.timeBasedSlabs.map(function (tb) {
                        // Ensure times are in 24-hour format before processing
                        var normalizedStartTime = _this.convertTo24Hour(tb.startTime || '');
                        var normalizedEndTime = _this.convertTo24Hour(tb.endTime || '');
                        return tslib_1.__assign({}, tb, { startTime: normalizedStartTime ? (normalizedStartTime.length === 5 ? normalizedStartTime + ':00' : normalizedStartTime) : normalizedStartTime, endTime: normalizedEndTime ? (normalizedEndTime.length === 5 ? normalizedEndTime + ':59' : normalizedEndTime) : normalizedEndTime });
                    });
                }
                else {
                    this.params.timeBasedSlabs = undefined;
                }
            }
            else {
                delete this.params.timeBasedSlabs;
                delete this.params.minimumPayout;
            }
            if (this.canSetDesiredCustomerPpkm && this.desiredCustomerPpkm != null) {
                this.params.desiredCustomerPpkm = this.desiredCustomerPpkm;
            }
            else {
                delete this.params.desiredCustomerPpkm;
            }
            // Clean up first/last mile if empty
            if (this.isEmpty(this.thresholdFareFM) && this.isEmpty(this.thresholdDistanceFM)) {
                this.thresholdFareFM = null;
                this.thresholdDistanceFM = null;
                this.minCompensationFM = null;
                this.maxCompensationFM = null;
            }
            if (this.isEmpty(this.thresholdFareLM) && this.isEmpty(this.thresholdDistanceLM)) {
                this.thresholdFareLM = null;
                this.thresholdDistanceLM = null;
            }
            this.params.active = true;
            this.params.thresholdDistanceFM = this.thresholdDistanceFM;
            this.params.thresholdFareFM = this.thresholdFareFM;
            this.params.maxCompensationFM = this.maxCompensationFM;
            this.params.minCompensationFM = this.minCompensationFM;
            // Only include last-mile fields for 'order' category (not for cm or distance)
            if (this.category === 'order') {
                this.params.thresholdDistanceLM = this.thresholdDistanceLM;
                this.params.thresholdFareLM = this.thresholdFareLM;
            }
            else {
                delete this.params.thresholdDistanceLM;
                delete this.params.thresholdFareLM;
            }
            this.params.excludeIncentiveTypes = (this.params.excludeIncentiveTypes || [])
                .filter(function (t) { return t && t.trim() !== ''; });
            this.params.isSurgeIncluded = true;
            // Always hardcode all days
            this.params.days = this.daysList.slice();
            this.validateCommission();
            this.validateFlatCommissionDeductions();
            this.validateSlabs();
            this.params.cities = [this.selectedCities];
            this.loadingIndicator = false;
            if (this.isGeoSlabPage) {
                this.lookupExistingGeoSlab().then(function () {
                    _this.showConfirmationModal = true;
                }).catch(function () { });
                return;
            }
            this.showConfirmationModal = true;
        }
        catch (e) {
            this.loadingIndicator = false;
        }
    };
    CreateSlabComponent.prototype.createTwoSlabs = function () {
        var _this = this;
        if (this.category === 'order') {
            var nonBatchedSlab = JSON.parse(JSON.stringify(this.finalSlabData));
            delete nonBatchedSlab.batchDetails;
            nonBatchedSlab.batchedOrder = false;
            var batchedSlab = JSON.parse(JSON.stringify(this.finalSlabData));
            batchedSlab.batchedOrder = true;
            this.deleteUnusedValues(batchedSlab);
            return [batchedSlab, nonBatchedSlab].map(function (slab) { return _this.toPoolDetailsPayload(slab); });
        }
        return [this.toPoolDetailsPayload(JSON.parse(JSON.stringify(this.finalSlabData)))];
    };
    // captain-earnings expects pool config as poolDetails { size, compensationMultipliers }
    // (CreatePoolDetails); the flat poolSize/poolMultipliers fields are UI-only.
    CreateSlabComponent.prototype.toPoolDetailsPayload = function (slab) {
        if (this.isPoolServiceSelected() && slab.poolSize >= 2) {
            slab.poolDetails = {
                size: slab.poolSize,
                compensationMultipliers: Utils.normalizePoolMultipliers(slab.poolMultipliers),
            };
        }
        delete slab.poolSize;
        delete slab.poolMultipliers;
        return slab;
    };
    CreateSlabComponent.prototype.deleteUnusedValues = function (slab) {
        ['commissionAmount', 'commissionType', 'commissionOnBonus',
            'peakSlab', 'nonPeakSlab', 'flexibleSlab', 'nightSlab',
            'thresholdDistanceFM', 'thresholdDistanceLM', 'thresholdFareFM',
            'thresholdFareLM', 'isSurgeIncluded', 'maxCompensationFM', 'minCompensationFM']
            .forEach(function (k) { return delete slab[k]; });
    };
    CreateSlabComponent.prototype.saveData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userEmail, user, error_3, twoSlabs;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isGeoSlabPage && !Array.isArray(this.params.shift)) {
                            this.params.shift = [this.params.shift];
                        }
                        if (!this.isBatchedOrder && this.params.commissionAmount != null) {
                            this.params.commissionAmount = this.params.commissionAmount.toString();
                        }
                        userEmail = '';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.authService.getUserDetails().toPromise()];
                    case 2:
                        user = _a.sent();
                        userEmail = (user && user.email) ? user.email : '';
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.error('Error fetching user details:', error_3);
                        return [3 /*break*/, 4];
                    case 4:
                        this.finalSlabData.createdBy = userEmail;
                        this.loadingIndicator = true;
                        twoSlabs = this.createTwoSlabs();
                        if (this.isGeoSlabPage) {
                            twoSlabs.forEach(function (slab) { return _this.applyGeoSlabPayloadFields(slab, userEmail); });
                        }
                        this.sharedService.createSlab(twoSlabs).toPromise()
                            .then(function () {
                            _this.loadingIndicator = false;
                            _this.showConfirmationModal = false;
                            _this.toasterService.showToaster(new Toaster({
                                type: ToasterType.SUCCESS,
                                message: _this.isGeoSlabPage
                                    ? (_this.existingGeoSlab
                                        ? 'Existing config for this hotspot and city is updated with the latest slab.'
                                        : 'Geo Slab successfully created')
                                    : 'Slab successfully created'
                            }));
                            _this.router.navigate(['/slabs']);
                        })
                            .catch(function (error) {
                            _this.loadingIndicator = false;
                            _this.showConfirmationModal = false;
                            var msg = (error && error.error && error.error.message) || (error && error.message) || 'Error creating slab';
                            _this.showError(msg);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateSlabComponent.prototype.cancelConfirmation = function () {
        var _this = this;
        var types = [
            'peakSlab', 'nonPeakSlab', 'flexibleSlab', 'nightSlab',
            'peakSlabBatchedFirstOrder', 'nonPeakSlabBatchedFirstOrder',
            'flexibleSlabBatchedFirstOrder', 'nightSlabBatchedFirstOrder',
            'peakSlabBatchedNextOrder', 'nonPeakSlabBatchedNextOrder',
            'flexibleSlabBatchedNextOrder', 'nightSlabBatchedNextOrder'
        ];
        if (this.persistValues) {
            types.forEach(function (t) {
                if (_this.persistValues[t] && _this.persistValues[t].timeData) {
                    _this.persistValues[t].timeData.forEach(function (td) {
                        delete td.timeFrom;
                        delete td.fromTime;
                        delete td.toTime;
                    });
                }
            });
            this.params = this.persistValues;
        }
        this.showConfirmationModal = false;
    };
    CreateSlabComponent.prototype.filteredServices = function () {
        if (!this.existingServiceSearch) {
            return this.services;
        }
        var query = this.existingServiceSearch.toLowerCase();
        return this.services.filter(function (s) { return s.service && s.service.name && s.service.name.toLowerCase().includes(query); });
    };
    CreateSlabComponent.prototype.filteredShifts = function () {
        if (!this.existingShiftSearch) {
            return this.shifts;
        }
        var query = this.existingShiftSearch.toLowerCase();
        return this.shifts.filter(function (s) { return s.toLowerCase().includes(query); });
    };
    // Utility functions
    CreateSlabComponent.prototype.formatDate = function (date) {
        if (!date) {
            return date;
        }
        var d = new Date(date);
        var yyyy = d.getFullYear();
        var mm = String(d.getMonth() + 1).padStart(2, '0');
        var dd = String(d.getDate()).padStart(2, '0');
        return yyyy + "-" + mm + "-" + dd;
    };
    CreateSlabComponent.prototype.showError = function (msg) {
        this.toasterService.showToaster(new Toaster({
            type: ToasterType.WARNING,
            message: msg,
            delay: 5000,
            config: { dismissible: true }
        }));
    };
    CreateSlabComponent.prototype.getViewModeDisplayText = function () {
        var _this = this;
        if (this.selectedModeNames && this.selectedModeNames.length > 0) {
            return this.selectedModeNames.join(', ');
        }
        if (this.selectedMode && this.modes && this.modes.length) {
            var match = this.modes.find(function (m) { return String(m.id) === String(_this.selectedMode); });
            if (match && match.name) {
                return match.name;
            }
        }
        if (this.selectedMode) {
            return this.selectedMode;
        }
        return '';
    };
    CreateSlabComponent.prototype.toastError = function (msg) {
        this.loadingIndicator = false;
        this.showError(msg);
        throw new Error(msg);
    };
    CreateSlabComponent.prototype.isMinimumGuaranteeEarningModel = function () {
        return this.params && this.params.earningModel === 'minimum_guarantee';
    };
    Object.defineProperty(CreateSlabComponent.prototype, "minimumGuaranteeFlowLoadingMessage", {
        get: function () {
            if (!this.isMinimumGuaranteeEarningModel()) {
                return null;
            }
            if (this.minimumGuaranteeSlabsLookupPending) {
                return 'MG details are loading, please wait.';
            }
            if (this.microCorridorsLoading) {
                return 'MC details are loading, please wait.';
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    CreateSlabComponent.prototype.getSelectedShiftCount = function () {
        var s = this.params && this.params.shift;
        if (s == null || s === '') {
            return 0;
        }
        if (Array.isArray(s)) {
            return s.filter(function (x) { return x != null && String(x).trim() !== ''; }).length;
        }
        return String(s).trim() === '' ? 0 : 1;
    };
    CreateSlabComponent.prototype.warnIfMinimumGuaranteeWithMultipleShifts = function () {
        if (!this.isMinimumGuaranteeEarningModel() || this.isViewMode) {
            return;
        }
        if (this.getSelectedShiftCount() > 1) {
            this.showError('Minimum Guarantee allows only one shift. Remove extra shifts before creating this slab.');
        }
    };
    // Pool Slab helpers
    /**
     * True only when all selected services share the same orderType and that
     * orderType is configured for pool slabs (dashboard config poolSlabOrderTypes).
     */
    CreateSlabComponent.prototype.isPoolServiceSelected = function () {
        var _this = this;
        var poolOrderTypes = (this.dashboardConfig && this.dashboardConfig.poolSlabOrderTypes) || [];
        var selected = this.params.serviceTypes || [];
        if (selected.length === 0) {
            return false;
        }
        var orderTypes = selected.map(function (id) {
            var entry = _this.serviceMap[id];
            return entry && entry.orderType;
        });
        var first = orderTypes[0];
        if (!first || poolOrderTypes.indexOf(first) === -1) {
            return false;
        }
        return orderTypes.every(function (orderType) { return orderType === first; });
    };
    CreateSlabComponent.prototype.showPoolFields = function () {
        if (this.isViewMode) {
            return this.params.poolSize != null;
        }
        return this.isPoolServiceSelected();
    };
    // Mirrors captain-earnings validatePoolSlab (internal/services/slab/validate.go)
    CreateSlabComponent.prototype.validatePoolSlab = function () {
        var _this = this;
        if (!this.isPoolServiceSelected()) {
            return;
        }
        if (!this.params.poolSize || this.params.poolSize < 2) {
            this.toastError('Pool size must be at least 2 for pool slabs');
        }
        var multipliers = Utils.normalizePoolMultipliers(this.params.poolMultipliers);
        Object.keys(multipliers).forEach(function (position) {
            var pos = parseInt(position, 10);
            if (isNaN(pos) || pos < 2 || pos > _this.params.poolSize) {
                _this.toastError("Pool multiplier slot " + position + " must be between 2 and pool size " + _this.params.poolSize);
            }
            var value = multipliers[position];
            if (value == null || isNaN(value) || value < 0 || value > 1) {
                _this.toastError("Pool multiplier for position " + position + " must be between 0% and 100%");
            }
        });
    };
    CreateSlabComponent.prototype.onPoolSizeChange = function () {
        var _this = this;
        if (!this.params.poolSize || this.params.poolSize < 2) {
            this.params.poolMultipliers = {};
            return;
        }
        // Drop multipliers for slot positions outside 2..poolSize
        var multipliers = Utils.normalizePoolMultipliers(this.params.poolMultipliers);
        Object.keys(multipliers).forEach(function (position) {
            var pos = parseInt(position, 10);
            if (isNaN(pos) || pos < 2 || pos > _this.params.poolSize) {
                delete multipliers[position];
            }
        });
        this.params.poolMultipliers = multipliers;
    };
    CreateSlabComponent.prototype.getPoolMultiplierPositions = function () {
        if (!this.params.poolSize || this.params.poolSize < 2) {
            return [];
        }
        // Return array [2, 3, 4, ...] up to poolSize
        var positions = [];
        for (var i = 2; i <= this.params.poolSize; i++) {
            positions.push(i);
        }
        return positions;
    };
    CreateSlabComponent.prototype.getPoolMultiplierValue = function (position) {
        var multipliers = this.params.poolMultipliers;
        if (multipliers == null || Array.isArray(multipliers)) {
            return null;
        }
        var value = multipliers[String(position)];
        // Convert decimal multiplier (0.75) to percentage (75) for display; null when unset
        return value != null ? value * 100 : null;
    };
    CreateSlabComponent.prototype.setPoolMultiplierValue = function (position, value) {
        if (this.params.poolMultipliers == null || Array.isArray(this.params.poolMultipliers)) {
            this.params.poolMultipliers = {};
        }
        // Convert string to number (from input event) and then percentage to decimal (75 -> 0.75).
        // Empty/invalid input unsets the slot instead of forcing a 0% multiplier.
        var numValue = typeof value === 'string' ? parseFloat(value) : value;
        if (numValue == null || isNaN(numValue)) {
            delete this.params.poolMultipliers[String(position)];
            return;
        }
        this.params.poolMultipliers[String(position)] = numValue / 100;
    };
    CreateSlabComponent.prototype.getPrimarySelectedShift = function () {
        var selectedShift = this.params && this.params.shift;
        if (Array.isArray(selectedShift)) {
            return selectedShift.length > 0 ? String(selectedShift[0]) : null;
        }
        if (typeof selectedShift === 'string' && selectedShift.trim() !== '') {
            return selectedShift;
        }
        return null;
    };
    Object.defineProperty(CreateSlabComponent.prototype, "minimumGuaranteeViewSlabsQueryParams", {
        get: function () {
            var shift = this.getPrimarySelectedShift();
            var out = { earningModel: 'minimum_guarantee' };
            if (shift) {
                out.shift = shift;
            }
            return out;
        },
        enumerable: true,
        configurable: true
    });
    CreateSlabComponent.prototype.openMinimumGuaranteeSlabsInNewWindow = function (event) {
        if (event) {
            event.preventDefault();
        }
        var url = this.router.serializeUrl(this.router.createUrlTree(['/slabs'], { queryParams: this.minimumGuaranteeViewSlabsQueryParams }));
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    CreateSlabComponent.prototype.isMinimumGuaranteeSlotTimeLocked = function () {
        return this.isViewMode || this.isMinimumGuaranteeReadOnly || this.selectedMicroCorridorIds.length > 0;
    };
    CreateSlabComponent.prototype.isMicroCorridorSelectionDisabled = function () {
        return this.isViewMode || this.isMinimumGuaranteeReadOnly;
    };
    Object.defineProperty(CreateSlabComponent.prototype, "showMinimumGuaranteeMicroCorridorField", {
        get: function () {
            if (!this.params || this.params.earningModel !== 'minimum_guarantee') {
                return false;
            }
            if (this.isViewMode) {
                var d = this.params.minimumGuaranteeDetails;
                return !!(d && d.microCorridorId);
            }
            var dMg = this.params.minimumGuaranteeDetails;
            if (this.isMinimumGuaranteeReadOnly) {
                var hasLockedMc = !!(dMg && dMg.microCorridorId);
                if (!this.minimumGuaranteeShiftRequiresMicroCorridorId && !hasLockedMc) {
                    return false;
                }
            }
            if (this.microCorridors.length > 0
                || this.minimumGuaranteeShiftRequiresMicroCorridorId
                || this.microCorridorsLoading
                || this.microCorridorsError
                || (this.isMinimumGuaranteeReadOnly && !!(dMg && dMg.microCorridorId))) {
                return true;
            }
            if (this.actionTitle === 'Duplicate') {
                var d = this.params.minimumGuaranteeDetails;
                return !!(d && d.microCorridorId);
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * ng-select with `[multiple]="true"` — model is an array; only one MicroCorridor is allowed (latest wins).
     */
    CreateSlabComponent.prototype.onMicroCorridorSelectionChange = function (ids) {
        this.ensureMinimumGuaranteeDetailsObject(false);
        var arr = Array.isArray(ids) ? ids.filter(function (id) { return id != null && String(id).trim() !== ''; }) : [];
        if (arr.length > 1) {
            arr = [arr[arr.length - 1]];
        }
        this.selectedMicroCorridorIds = arr.slice();
        this.applySelectedMicroCorridorToMinimumGuarantee();
    };
    CreateSlabComponent.prototype.retryMicroCorridorLookup = function () {
        this.microCorridorsError = false;
        this.microCorridorsErrorCanRetry = true;
        this.microCorridorsErrorMessage = this.defaultMicroCorridorsErrorMessage;
        this.evaluateMicroCorridorState(true);
    };
    CreateSlabComponent.prototype.applySelectedMicroCorridorToMinimumGuarantee = function () {
        if (!this.isMinimumGuaranteeEarningModel()) {
            return;
        }
        this.ensureMinimumGuaranteeDetailsObject(false);
        var selectedMcId = this.selectedMicroCorridorIds.length > 0
            ? String(this.selectedMicroCorridorIds[0])
            : null;
        if (!selectedMcId) {
            this.params.minimumGuaranteeDetails.microCorridorId = null;
            this.params.minimumGuaranteeDetails.slots = this.normalizeSlotCount([
                { startTime: '', endTime: '' }
            ]);
            return;
        }
        var selectedMicroCorridor = this.microCorridors.find(function (mc) { return String(mc.id) === selectedMcId || String(mc.zoneId) === selectedMcId; });
        if (!selectedMicroCorridor) {
            this.params.minimumGuaranteeDetails.microCorridorId = null;
            this.params.minimumGuaranteeDetails.slots = this.normalizeSlotCount([
                { startTime: '', endTime: '' }
            ]);
            return;
        }
        this.params.minimumGuaranteeDetails.microCorridorId = selectedMicroCorridor.id;
        this.params.minimumGuaranteeDetails.slots = [{
                startTime: selectedMicroCorridor.startTime,
                endTime: selectedMicroCorridor.endTime
            }];
    };
    CreateSlabComponent.prototype.buildMicroCorridorContextKey = function () {
        if (!this.isMinimumGuaranteeEarningModel()) {
            return null;
        }
        var city = this.selectedCities || '';
        var serviceTypes = Array.isArray(this.params.serviceTypes)
            ? this.params.serviceTypes.filter(function (sd) { return !!sd; }).slice().sort()
            : [];
        if (!city || serviceTypes.length === 0) {
            return null;
        }
        return city + "::" + serviceTypes.join(',');
    };
    CreateSlabComponent.prototype.resetMicroCorridorState = function (clearSelection) {
        this.microCorridors = [];
        this.microCorridorsLoading = false;
        this.microCorridorsError = false;
        this.microCorridorsErrorCanRetry = true;
        this.microCorridorsErrorMessage = this.defaultMicroCorridorsErrorMessage;
        this.currentMicroCorridorContextKey = null;
        this.syncMinimumGuaranteeLoadingOverlay();
        if (!clearSelection) {
            return;
        }
        this.selectedMicroCorridorIds = [];
        if (this.params && this.params.minimumGuaranteeDetails) {
            this.params.minimumGuaranteeDetails.microCorridorId = null;
        }
    };
    CreateSlabComponent.prototype.evaluateMicroCorridorState = function (forceRefresh) {
        if (forceRefresh === void 0) { forceRefresh = false; }
        if (!this.isMinimumGuaranteeEarningModel()) {
            this.resetMicroCorridorState(true);
            return;
        }
        this.ensureMinimumGuaranteeDetailsObject(false);
        if (!forceRefresh && this.isMinimumGuaranteeReadOnly && !this.params.minimumGuaranteeDetails.microCorridorId) {
            this.resetMicroCorridorState(true);
            return;
        }
        if (this.selectedMicroCorridorIds.length === 0 && this.params.minimumGuaranteeDetails.microCorridorId) {
            this.selectedMicroCorridorIds = [String(this.params.minimumGuaranteeDetails.microCorridorId)];
        }
        var contextKey = this.buildMicroCorridorContextKey();
        if (!contextKey) {
            this.resetMicroCorridorState(true);
            return;
        }
        if (forceRefresh) {
            delete this.microCorridorLookupCache[contextKey];
        }
        if (!forceRefresh && this.currentMicroCorridorContextKey === contextKey && this.microCorridors.length > 0) {
            return;
        }
        if (!forceRefresh && this.microCorridorLookupCache[contextKey]) {
            this.currentMicroCorridorContextKey = contextKey;
            this.microCorridors = this.microCorridorLookupCache[contextKey].slice();
            this.microCorridorsLoading = false;
            this.microCorridorsError = false;
            this.reconcileMicroCorridorSelectionWithOptions();
            return;
        }
        if (this.microCorridorLookupInFlight[contextKey]) {
            return;
        }
        this.currentMicroCorridorContextKey = contextKey;
        this.fetchMicroCorridorsForCurrentContext(contextKey);
    };
    CreateSlabComponent.prototype.extractMicroCorridorSlotTime = function (enabledTimeSlots, key) {
        if (!Array.isArray(enabledTimeSlots) || enabledTimeSlots.length === 0) {
            return '';
        }
        var firstTimeSlot = enabledTimeSlots[0] || {};
        var durations = Array.isArray(firstTimeSlot.duration) ? firstTimeSlot.duration : [];
        if (durations.length === 0) {
            return '';
        }
        var raw = durations[0] && durations[0][key] != null ? String(durations[0][key]) : '';
        if (!raw) {
            return '';
        }
        if (raw.length === 4 && /^\d{4}$/.test(raw)) {
            return raw.slice(0, 2) + ":" + raw.slice(2, 4);
        }
        return this.convertTo24Hour(raw);
    };
    CreateSlabComponent.prototype.normalizeMicroCorridorOption = function (rawMicroCorridor) {
        if (!rawMicroCorridor || typeof rawMicroCorridor !== 'object') {
            return null;
        }
        var zoneIdCandidate = rawMicroCorridor.zoneId != null ? rawMicroCorridor.zoneId : rawMicroCorridor.id;
        if (!zoneIdCandidate) {
            return null;
        }
        var startTimeRaw = rawMicroCorridor.startTime || this.extractMicroCorridorSlotTime(rawMicroCorridor.enabledTimeSlots, 'start');
        var endTimeRaw = rawMicroCorridor.endTime || this.extractMicroCorridorSlotTime(rawMicroCorridor.enabledTimeSlots, 'end');
        return {
            id: rawMicroCorridor.id != null ? String(rawMicroCorridor.id) : String(zoneIdCandidate),
            name: rawMicroCorridor.name ? String(rawMicroCorridor.name) : String(zoneIdCandidate),
            zoneId: String(zoneIdCandidate),
            startTime: this.convertTo24Hour(startTimeRaw || ''),
            endTime: this.convertTo24Hour(endTimeRaw || '')
        };
    };
    CreateSlabComponent.prototype.fetchMicroCorridorsForCurrentContext = function (contextKey) {
        var _this = this;
        var cityObj = this.cities.find(function (c) { return c.displayName === _this.selectedCities; });
        var serviceDetailIds = Array.isArray(this.params.serviceTypes)
            ? this.params.serviceTypes.filter(function (sd) { return !!sd; })
            : [];
        if (!cityObj || serviceDetailIds.length === 0) {
            this.resetMicroCorridorState(true);
            return;
        }
        this.microCorridorsLoading = true;
        this.microCorridorsError = false;
        this.microCorridorsErrorCanRetry = true;
        this.microCorridorsErrorMessage = this.defaultMicroCorridorsErrorMessage;
        this.syncMinimumGuaranteeLoadingOverlay();
        this.microCorridorLookupInFlight[contextKey] = true;
        var payload = {
            cityId: cityObj._id,
            serviceDetailIds: serviceDetailIds
        };
        this.sharedService.fetchMicroCorridors(payload).toPromise()
            .then(function (res) {
            if (!_this.isMinimumGuaranteeEarningModel() || _this.currentMicroCorridorContextKey !== contextKey) {
                return;
            }
            var rawMicroCorridors = (res && Array.isArray(res.microCorridors))
                ? res.microCorridors
                : ((res && res.data && Array.isArray(res.data.microCorridors)) ? res.data.microCorridors : []);
            var mapped = rawMicroCorridors
                .map(function (mc) { return _this.normalizeMicroCorridorOption(mc); })
                .filter(function (mc) { return !!mc; });
            _this.microCorridors = mapped.filter(function (mc) { return !!mc.name; });
            if (_this.microCorridors.length === 0) {
                _this.selectedMicroCorridorIds = [];
                _this.params.minimumGuaranteeDetails.microCorridorId = null;
                _this.microCorridorsError = true;
                _this.microCorridorsErrorCanRetry = false;
                _this.microCorridorsErrorMessage = _this.microCorridorsEmptyErrorMessage;
                delete _this.microCorridorLookupCache[contextKey];
                return;
            }
            _this.microCorridorLookupCache[contextKey] = _this.microCorridors.slice();
            _this.reconcileMicroCorridorSelectionWithOptions();
        })
            .catch(function () {
            if (!_this.isMinimumGuaranteeEarningModel() || _this.currentMicroCorridorContextKey !== contextKey) {
                return;
            }
            _this.microCorridors = [];
            _this.selectedMicroCorridorIds = [];
            _this.params.minimumGuaranteeDetails.microCorridorId = null;
            _this.microCorridorsError = true;
            _this.microCorridorsErrorCanRetry = true;
            _this.microCorridorsErrorMessage = _this.defaultMicroCorridorsErrorMessage;
            delete _this.microCorridorLookupCache[contextKey];
        })
            .finally(function () {
            delete _this.microCorridorLookupInFlight[contextKey];
            if (_this.currentMicroCorridorContextKey === contextKey) {
                _this.microCorridorsLoading = false;
                _this.syncMinimumGuaranteeLoadingOverlay();
            }
        });
    };
    CreateSlabComponent.prototype.reconcileMicroCorridorSelectionWithOptions = function () {
        if (this.microCorridors.length === 0) {
            this.selectedMicroCorridorIds = [];
            this.params.minimumGuaranteeDetails.microCorridorId = null;
            return;
        }
        var activeSelection = (this.selectedMicroCorridorIds.length > 0
            ? this.selectedMicroCorridorIds[0]
            : null) || this.params.minimumGuaranteeDetails.microCorridorId;
        if (activeSelection) {
            var matched = this.microCorridors.find(function (mc) { return String(mc.id) === String(activeSelection) || String(mc.zoneId) === String(activeSelection); });
            if (matched) {
                this.selectedMicroCorridorIds = [matched.id];
                this.applySelectedMicroCorridorToMinimumGuarantee();
                return;
            }
        }
        if (!this.isMinimumGuaranteeReadOnly) {
            this.selectedMicroCorridorIds = [];
            this.params.minimumGuaranteeDetails.microCorridorId = null;
        }
    };
    CreateSlabComponent.prototype.buildMinimumGuaranteeContextKey = function () {
        if (!this.isMinimumGuaranteeEarningModel()) {
            return null;
        }
        var city = this.selectedCities || '';
        var mode = this.selectedMode || this.mode || '';
        var shift = this.getPrimarySelectedShift();
        var serviceTypes = Array.isArray(this.params.serviceTypes)
            ? this.params.serviceTypes.slice().sort()
            : [];
        if (!city || !mode || !shift || serviceTypes.length === 0) {
            return null;
        }
        return city + "::" + mode + "::" + shift + "::" + serviceTypes.join(',');
    };
    CreateSlabComponent.prototype.ensureMinimumGuaranteeDetailsObject = function (resetValues) {
        if (!this.isMinimumGuaranteeEarningModel()) {
            delete this.params.minimumGuaranteeDetails;
            return;
        }
        if (resetValues || !this.params.minimumGuaranteeDetails || typeof this.params.minimumGuaranteeDetails !== 'object') {
            this.params.minimumGuaranteeDetails = {
                eligibilityCriteria: { orders: null },
                minimumGuaranteeAmount: null,
                perceptionAmount: null,
                slots: this.buildMinimumGuaranteeSlots(),
                microCorridorId: null
            };
            return;
        }
        var mgDetails = this.params.minimumGuaranteeDetails;
        if (!mgDetails.eligibilityCriteria || typeof mgDetails.eligibilityCriteria !== 'object') {
            mgDetails.eligibilityCriteria = { orders: null };
        }
        mgDetails.slots = this.normalizeSlotCount(mgDetails.slots || []);
        if (mgDetails.microCorridorId == null || mgDetails.microCorridorId === '') {
            mgDetails.microCorridorId = null;
        }
        else {
            mgDetails.microCorridorId = String(mgDetails.microCorridorId);
        }
    };
    CreateSlabComponent.prototype.applyMinimumGuaranteeFromLoadedSlabDocument = function () {
        var raw = this.params.minimumGuaranteeDetails;
        var normalized = this.normalizeMinimumGuaranteeDetailsFromSlab(raw);
        if (normalized) {
            this.params.minimumGuaranteeDetails = JSON.parse(JSON.stringify(normalized));
        }
        else if (raw && typeof raw === 'object') {
            this.params.minimumGuaranteeDetails = JSON.parse(JSON.stringify(raw));
            this.ensureMinimumGuaranteeDetailsObject(false);
        }
        else {
            delete this.params.minimumGuaranteeDetails;
            this.ensureMinimumGuaranteeDetailsObject(true);
        }
        if (this.params.minimumGuaranteeDetails) {
            this.params.minimumGuaranteeDetails.slots = this.normalizeSlotCount(this.params.minimumGuaranteeDetails.slots || []);
            this.selectedMicroCorridorIds = this.params.minimumGuaranteeDetails.microCorridorId
                ? [String(this.params.minimumGuaranteeDetails.microCorridorId)]
                : [];
        }
        this.isMinimumGuaranteeReadOnly = this.isViewMode;
        this.showMinimumGuaranteeBanner = false;
        this.currentMinimumGuaranteeContextKey = this.buildMinimumGuaranteeContextKey();
        this.minimumGuaranteeSlabsLookupPending = false;
        this.minimumGuaranteeSlabsLookupError = false;
        this.syncMinimumGuaranteeLoadingOverlay();
    };
    CreateSlabComponent.prototype.evaluateMinimumGuaranteeState = function (forceContextRefresh) {
        var _this = this;
        if (forceContextRefresh === void 0) { forceContextRefresh = false; }
        if (!this.isMinimumGuaranteeEarningModel()) {
            delete this.params.minimumGuaranteeDetails;
            this.isMinimumGuaranteeReadOnly = false;
            this.showMinimumGuaranteeBanner = false;
            this.currentMinimumGuaranteeContextKey = null;
            this.minimumGuaranteeSlabsLookupPending = false;
            this.minimumGuaranteeSlabsLookupError = false;
            this.minimumGuaranteeShiftRequiresMicroCorridorId = false;
            this.resetMicroCorridorState(true);
            this.syncMinimumGuaranteeLoadingOverlay();
            return;
        }
        if (this.isViewMode) {
            this.applyMinimumGuaranteeFromLoadedSlabDocument();
            this.evaluateMicroCorridorState(false);
            return;
        }
        if (this.actionTitle === 'Duplicate' && !forceContextRefresh) {
            this.applyMinimumGuaranteeFromLoadedSlabDocument();
            this.evaluateMicroCorridorState(false);
            this.refreshMinimumGuaranteeShiftMicroCorridorRequirement();
            return;
        }
        var contextKey = this.buildMinimumGuaranteeContextKey();
        if (!contextKey) {
            this.currentMinimumGuaranteeContextKey = null;
            this.isMinimumGuaranteeReadOnly = false;
            this.showMinimumGuaranteeBanner = false;
            delete this.params.minimumGuaranteeDetails;
            this.ensureMinimumGuaranteeDetailsObject(true);
            this.minimumGuaranteeSlabsLookupPending = false;
            this.minimumGuaranteeSlabsLookupError = false;
            this.minimumGuaranteeShiftRequiresMicroCorridorId = false;
            this.resetMicroCorridorState(true);
            this.syncMinimumGuaranteeLoadingOverlay();
            return;
        }
        var contextChanged = forceContextRefresh || this.currentMinimumGuaranteeContextKey !== contextKey;
        this.currentMinimumGuaranteeContextKey = contextKey;
        if (contextChanged) {
            this.showMinimumGuaranteeBanner = false;
        }
        if (forceContextRefresh) {
            delete this.minimumGuaranteeLookupCache[contextKey];
        }
        var cachedResult = this.minimumGuaranteeLookupCache[contextKey];
        if (cachedResult) {
            this.minimumGuaranteeSlabsLookupPending = false;
            this.minimumGuaranteeSlabsLookupError = false;
            this.syncMinimumGuaranteeLoadingOverlay();
            this.applyMinimumGuaranteeLookupResult(cachedResult, contextKey);
            this.evaluateMicroCorridorState(false);
            return;
        }
        if (this.minimumGuaranteeLookupInFlight[contextKey]) {
            return;
        }
        this.minimumGuaranteeLookupInFlight[contextKey] = true;
        this.minimumGuaranteeSlabsLookupError = false;
        this.minimumGuaranteeSlabsLookupPending = true;
        this.syncMinimumGuaranteeLoadingOverlay();
        var lookupContextKey = contextKey;
        this.fetchMinimumGuaranteeDetailsForCurrentContext()
            .then(function (lookupResult) {
            _this.minimumGuaranteeLookupCache[lookupContextKey] = lookupResult;
            if (_this.currentMinimumGuaranteeContextKey !== lookupContextKey || !_this.isMinimumGuaranteeEarningModel()) {
                return;
            }
            _this.minimumGuaranteeSlabsLookupError = false;
            _this.applyMinimumGuaranteeLookupResult(lookupResult, lookupContextKey);
            _this.evaluateMicroCorridorState(false);
        })
            .catch(function () {
            if (_this.currentMinimumGuaranteeContextKey !== lookupContextKey || !_this.isMinimumGuaranteeEarningModel()) {
                return;
            }
            _this.minimumGuaranteeSlabsLookupError = true;
            delete _this.params.minimumGuaranteeDetails;
            _this.isMinimumGuaranteeReadOnly = false;
            _this.showMinimumGuaranteeBanner = false;
            _this.loadingIndicator = false;
            _this.minimumGuaranteeShiftRequiresMicroCorridorId = false;
            _this.resetMicroCorridorState(true);
            _this.showError(_this.minimumGuaranteeSlabsLookupErrorMessage);
        })
            .finally(function () {
            delete _this.minimumGuaranteeLookupInFlight[lookupContextKey];
            if (_this.currentMinimumGuaranteeContextKey === lookupContextKey && _this.isMinimumGuaranteeEarningModel()) {
                _this.minimumGuaranteeSlabsLookupPending = false;
                _this.syncMinimumGuaranteeLoadingOverlay();
            }
        });
    };
    CreateSlabComponent.prototype.retryMinimumGuaranteeSlabsLookup = function () {
        if (!this.isMinimumGuaranteeEarningModel()) {
            return;
        }
        var contextKey = this.buildMinimumGuaranteeContextKey();
        if (contextKey) {
            delete this.minimumGuaranteeLookupCache[contextKey];
        }
        this.minimumGuaranteeSlabsLookupError = false;
        this.evaluateMinimumGuaranteeState(true);
    };
    CreateSlabComponent.prototype.fetchMinimumGuaranteeDetailsForCurrentContext = function () {
        var _this = this;
        var selectedShift = this.getPrimarySelectedShift();
        if (!selectedShift) {
            return Promise.resolve({
                hasConstruct: false,
                details: null,
                shiftRequiresMicroCorridorIdForMg: false
            });
        }
        var payload = {
            limit: 100,
            offset: 0,
            filters: {
                cities: this.selectedCities ? [this.selectedCities] : [],
                shifts: [selectedShift],
                active: true,
                earningModel: ['minimum_guarantee'],
            },
            responseParams: {
                requiredFields: ['earningModel', 'minimumGuaranteeDetails'],
            },
        };
        return this.sharedService.fetchSlabs(payload).toPromise()
            .then(function (res) {
            var slabs = res && Array.isArray(res.slabs) ? res.slabs : [];
            var minimumGuaranteeDetails = _this.extractMinimumGuaranteeDetailsFromSlabs(slabs, selectedShift);
            var shiftRequiresMicroCorridorIdForMg = _this.anyMinimumGuaranteeSlabOnShiftHasMicroCorridorId(slabs, selectedShift);
            return {
                hasConstruct: !!minimumGuaranteeDetails,
                details: minimumGuaranteeDetails,
                shiftRequiresMicroCorridorIdForMg: shiftRequiresMicroCorridorIdForMg
            };
        });
    };
    CreateSlabComponent.prototype.slabShiftMatchesSelectedShift = function (slab, selectedShift) {
        var slabShift = slab && slab.shift;
        return Array.isArray(slabShift)
            ? slabShift.some(function (s) { return String(s) === String(selectedShift); })
            : String(slabShift || '') === String(selectedShift);
    };
    CreateSlabComponent.prototype.anyMinimumGuaranteeSlabOnShiftHasMicroCorridorId = function (slabs, selectedShift) {
        if (slabs.length === 0) {
            return false;
        }
        for (var _i = 0, slabs_1 = slabs; _i < slabs_1.length; _i++) {
            var slab = slabs_1[_i];
            if (!this.slabShiftMatchesSelectedShift(slab, selectedShift)) {
                continue;
            }
            if (!slab || slab.earningModel !== 'minimum_guarantee') {
                continue;
            }
            var rawMg = slab.minimumGuaranteeDetails;
            if (!rawMg) {
                continue;
            }
            if (rawMg.microCorridorId) {
                return true;
            }
        }
        return false;
    };
    /** Duplicate / late binding: shift policy when MG lookup short-circuits without slab list. */
    CreateSlabComponent.prototype.refreshMinimumGuaranteeShiftMicroCorridorRequirement = function () {
        var _this = this;
        var selectedShift = this.getPrimarySelectedShift();
        if (!selectedShift || !this.selectedCities || !this.isMinimumGuaranteeEarningModel()) {
            this.minimumGuaranteeShiftRequiresMicroCorridorId = false;
            return;
        }
        var payload = {
            limit: 100,
            offset: 0,
            filters: {
                cities: this.selectedCities ? [this.selectedCities] : [],
                shifts: [selectedShift],
                active: true,
                earningModel: ['minimum_guarantee'],
            },
            responseParams: {
                requiredFields: ['minimumGuaranteeDetails', 'earningModel'],
            },
        };
        this.sharedService.fetchSlabs(payload).toPromise()
            .then(function (res) {
            var slabs = res && Array.isArray(res.slabs) ? res.slabs : [];
            var fromShift = _this.anyMinimumGuaranteeSlabOnShiftHasMicroCorridorId(slabs, selectedShift);
            var fromLoaded = !!(_this.params.minimumGuaranteeDetails
                && _this.params.minimumGuaranteeDetails.microCorridorId);
            _this.minimumGuaranteeShiftRequiresMicroCorridorId = fromShift || fromLoaded;
        })
            .catch(function () {
            _this.minimumGuaranteeShiftRequiresMicroCorridorId = false;
        });
    };
    CreateSlabComponent.prototype.extractMinimumGuaranteeDetailsFromSlabs = function (slabs, selectedShift) {
        if (!Array.isArray(slabs)) {
            return null;
        }
        for (var _i = 0, slabs_2 = slabs; _i < slabs_2.length; _i++) {
            var slab = slabs_2[_i];
            if (!this.slabShiftMatchesSelectedShift(slab, selectedShift)) {
                continue;
            }
            var details = this.normalizeMinimumGuaranteeDetailsFromSlab(slab && slab.minimumGuaranteeDetails);
            if (details) {
                return details;
            }
        }
        return null;
    };
    CreateSlabComponent.prototype.normalizeMinimumGuaranteeDetailsFromSlab = function (rawDetails) {
        var _this = this;
        if (!rawDetails || typeof rawDetails !== 'object') {
            return null;
        }
        var orders = rawDetails.eligibilityCriteria && rawDetails.eligibilityCriteria.orders;
        var minimumGuaranteeAmount = rawDetails.minimumGuaranteeAmount;
        var perceptionAmount = rawDetails.perceptionAmount;
        var allSlots = this.normalizeSlotCount(Array.isArray(rawDetails.slots) ? rawDetails.slots : []);
        var slots = allSlots
            .filter(function (slot) { return slot && slot.startTime && slot.endTime; })
            .map(function (slot) { return ({
            startTime: _this.convertTo24Hour(slot.startTime),
            endTime: _this.convertTo24Hour(slot.endTime)
        }); });
        var hasValidOrders = orders != null && orders !== '' && !isNaN(Number(orders));
        var hasValidMinimumGuaranteeAmount = minimumGuaranteeAmount != null && minimumGuaranteeAmount !== '' && !isNaN(Number(minimumGuaranteeAmount));
        var hasValidPerceptionAmount = (perceptionAmount == null || perceptionAmount === '' || !isNaN(Number(perceptionAmount)));
        if (!hasValidOrders || !hasValidMinimumGuaranteeAmount || !hasValidPerceptionAmount || slots.length === 0) {
            return null;
        }
        var normalizedPerceptionAmount = perceptionAmount == null || perceptionAmount === ''
            ? null
            : Number(perceptionAmount);
        return {
            eligibilityCriteria: {
                orders: Number(orders)
            },
            minimumGuaranteeAmount: Number(minimumGuaranteeAmount),
            perceptionAmount: normalizedPerceptionAmount,
            slots: slots,
            microCorridorId: rawDetails.microCorridorId
        };
    };
    CreateSlabComponent.prototype.collectMinimumGuaranteeValidationErrors = function () {
        var errors = [];
        var d = this.params.minimumGuaranteeDetails;
        if (!d || typeof d !== 'object') {
            return ['Minimum Guarantee details are missing.'];
        }
        var maxSlots = this.minimumGuaranteeSlotCount;
        var slots = Array.isArray(d.slots) ? d.slots : [];
        if (slots.length > maxSlots) {
            errors.push("You cannot have more than " + maxSlots + " Minimum Guarantee time slot" + (maxSlots === 1 ? '' : 's') + " " +
                "(configured maximum).");
        }
        if (slots.length < 1) {
            errors.push('At least one Minimum Guarantee time slot is required.');
        }
        var orders = d.eligibilityCriteria && d.eligibilityCriteria.orders;
        if (orders == null || orders === '' || isNaN(Number(orders))) {
            errors.push('MG Eligibility Orders is required and must be a valid number.');
        }
        var mga = d.minimumGuaranteeAmount;
        if (mga == null || mga === '' || isNaN(Number(mga))) {
            errors.push('Minimum Guarantee Amount is required and must be a valid number.');
        }
        var per = d.perceptionAmount;
        if (per != null && per !== '' && isNaN(Number(per))) {
            errors.push('Perception Amount must be a valid number when provided.');
        }
        if (!this.microCorridorsLoading
            && this.minimumGuaranteeShiftRequiresMicroCorridorId
            && !d.microCorridorId) {
            errors.push('MicroCorridor ID is required: an existing Minimum Guarantee slab for this shift includes a MicroCorridor. ' +
                'Select one when the list loads, or retry if the list is empty.');
        }
        for (var i = 0; i < slots.length; i += 1) {
            var slot = slots[i];
            var hasStart = !!(slot && slot.startTime);
            var hasEnd = !!(slot && slot.endTime);
            if (!hasStart && !hasEnd) {
                errors.push("Slot " + (i + 1) + ": start time and end time are required.");
            }
            else if (!hasStart) {
                errors.push("Slot " + (i + 1) + ": start time is required.");
            }
            else if (!hasEnd) {
                errors.push("Slot " + (i + 1) + ": end time is required.");
            }
        }
        return errors;
    };
    CreateSlabComponent.prototype.normalizeMinimumGuaranteeDetailsForSave = function (rawDetails) {
        var _this = this;
        if (!rawDetails || typeof rawDetails !== 'object') {
            return null;
        }
        var orders = rawDetails.eligibilityCriteria && rawDetails.eligibilityCriteria.orders;
        var minimumGuaranteeAmount = rawDetails.minimumGuaranteeAmount;
        var perceptionAmount = rawDetails.perceptionAmount;
        var allSlots = this.normalizeSlotCount(Array.isArray(rawDetails.slots) ? rawDetails.slots : []);
        var slots = allSlots
            .filter(function (slot) { return slot && slot.startTime && slot.endTime; })
            .map(function (slot) { return ({
            startTime: _this.convertTo24Hour(slot.startTime),
            endTime: _this.convertTo24Hour(slot.endTime)
        }); });
        var normalizedPerceptionAmount = perceptionAmount == null || perceptionAmount === ''
            ? null
            : Number(perceptionAmount);
        return {
            eligibilityCriteria: {
                orders: Number(orders)
            },
            minimumGuaranteeAmount: Number(minimumGuaranteeAmount),
            perceptionAmount: normalizedPerceptionAmount,
            slots: slots,
            microCorridorId: rawDetails.microCorridorId
        };
    };
    CreateSlabComponent.prototype.applyMinimumGuaranteeLookupResult = function (lookupResult, contextKey) {
        if (this.currentMinimumGuaranteeContextKey !== contextKey || !this.isMinimumGuaranteeEarningModel()) {
            return;
        }
        this.minimumGuaranteeShiftRequiresMicroCorridorId = !!lookupResult.shiftRequiresMicroCorridorIdForMg;
        if (lookupResult.hasConstruct && lookupResult.details) {
            this.params.minimumGuaranteeDetails = JSON.parse(JSON.stringify(lookupResult.details));
            this.params.minimumGuaranteeDetails.slots = this.normalizeSlotCount(this.params.minimumGuaranteeDetails.slots || []);
            this.selectedMicroCorridorIds = this.params.minimumGuaranteeDetails.microCorridorId
                ? [String(this.params.minimumGuaranteeDetails.microCorridorId)]
                : [];
            this.isMinimumGuaranteeReadOnly = true;
            this.showMinimumGuaranteeBanner = !this.minimumGuaranteeBannerDismissedByContext[contextKey];
            return;
        }
        delete this.params.minimumGuaranteeDetails;
        this.ensureMinimumGuaranteeDetailsObject(true);
        this.selectedMicroCorridorIds = [];
        this.isMinimumGuaranteeReadOnly = false;
        this.showMinimumGuaranteeBanner = false;
    };
    CreateSlabComponent.prototype.validateMinimumGuaranteeDetails = function () {
        if (!this.isMinimumGuaranteeEarningModel()) {
            delete this.params.minimumGuaranteeDetails;
            return;
        }
        var validationErrors = this.collectMinimumGuaranteeValidationErrors();
        if (validationErrors.length > 0) {
            this.toastError(validationErrors.join(' '));
        }
        var normalizedDetails = this.normalizeMinimumGuaranteeDetailsForSave(this.params.minimumGuaranteeDetails);
        if (!normalizedDetails || !normalizedDetails.slots || normalizedDetails.slots.length === 0) {
            this.toastError('Minimum Guarantee time slots could not be saved. Please check slot times.');
        }
        this.params.minimumGuaranteeDetails = normalizedDetails;
    };
    CreateSlabComponent.prototype.parseMinimumGuaranteeSlotCount = function (rawCount) {
        var parsed = Number(rawCount);
        if (!Number.isFinite(parsed) || parsed < 1) {
            return 1;
        }
        return Math.floor(parsed);
    };
    CreateSlabComponent.prototype.buildMinimumGuaranteeSlots = function () {
        return [{ startTime: '', endTime: '' }];
    };
    CreateSlabComponent.prototype.getSafeMinimumGuaranteeSlotLimit = function (currentSlotCount) {
        var configuredSlotCount = Number(this.minimumGuaranteeSlotCount);
        if (!Number.isFinite(configuredSlotCount) || configuredSlotCount < 1) {
            return currentSlotCount;
        }
        var normalizedConfiguredSlotCount = Math.floor(configuredSlotCount);
        if (normalizedConfiguredSlotCount === 1 && currentSlotCount > 1) {
            return currentSlotCount;
        }
        return normalizedConfiguredSlotCount;
    };
    CreateSlabComponent.prototype.normalizeSlotCount = function (rawSlots) {
        var _this = this;
        var normalized = (rawSlots || []).map(function (slot) { return ({
            startTime: slot && slot.startTime ? _this.convertTo24Hour(slot.startTime) : '',
            endTime: slot && slot.endTime ? _this.convertTo24Hour(slot.endTime) : ''
        }); });
        if (normalized.length === 0) {
            return [{ startTime: '', endTime: '' }];
        }
        var maxSlots = this.getSafeMinimumGuaranteeSlotLimit(normalized.length);
        return normalized.slice(0, maxSlots);
    };
    CreateSlabComponent.prototype.syncMinimumGuaranteeSlotsInState = function () {
        if (!this.params || !this.params.minimumGuaranteeDetails) {
            return;
        }
        this.params.minimumGuaranteeDetails.slots = this.normalizeSlotCount(this.params.minimumGuaranteeDetails.slots || []);
    };
    return CreateSlabComponent;
}());
export { CreateSlabComponent };
